const resources = {
  en: {
    translation: {
      login: 'Log in',
      register: 'Register',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      emailPlaceholder: 'Enter your email',
      usernamePlaceholder: 'Enter your username',
      passwordPlaceholder: 'Enter your password',
      confirmPasswordPlaceholder: 'Confirm your password',
      rememberPassword: 'Remember your password?',
      haveAccount: 'Already have an account? Log in here',
      noAccount: "Don't have an account? Register here",
      tissouraLogoAlt: 'Tissoura Logo',
      dashboard: 'Dashboard',
      profile: 'Profile',
      statistics: 'Statistics',
      messages: 'Messages',
      notifications: 'Notifications',
      settings: 'Settings',
      user: 'User',
      users: 'Users',
      firstName: 'First Name',
      lastName: 'Last Name',
      status: 'Status',
      actions: 'Actions',
      details: 'Details',
      edit: 'Edit',
      delete: 'Delete',
      addUser: 'Add User',
      userDetails: 'User Details',
      id: 'ID',
      email: 'Email',
      active: 'Active',
      inactive: 'Inactive',
      save: 'Save',
      close: 'Close',
      name: "Name",
      phone: "Phone",
      address: "Address",
      userPages: 'User pages',
      search: 'Search...',
      personalData: 'Personal Data',
      role: 'Role',
      totalUsers: "Total Users",
      activeUsers: "Active Users",
      pendingTasks: "Pending Tasks",
      completedTasks: "Completed Tasks",
      totalRevenue: "Total Revenue",
      newOrders:" New Orders",
      conversionRate: "Conversion Rate",
      siteVisits: "Site Visits",
      userGrowth: "User Growth",
      newUserRegistered: "New user registered",
      serverDowntime: "Server downtime",
      newOrderReceived: "New order received",
      userFeedbackReceived: "User feedback eceived",
      students: "Students",
      Employee: "Employee",
      documents: "Documents",
      logout: "Logout",
      welcomeTitle: "Welcome to Tissoura",
      welcomeDescription1: "At Tissoura, we offer high-quality education to foster the growth and development of our students. Join us to give your children the best start in life.",
      welcomeDescription2: "Our school comprises two institutions: Tissoura Primaire and Tissoura CEM, each dedicated to providing exceptional education at every stage of your child's learning journey.",
      servicesTitle: "Our Services",
      servicesDescription: "We offer a range of educational services tailored to the needs of our students, including personalized learning plans, extracurricular activities, and state-of-the-art facilities.",
      contactTitle: "Contact Us",
      contactDescription: "If you have any questions or would like to learn more about our programs, feel free to contact us.",
      joinUsButton: "Join us now",
      about: "About",
      services: "Services",
      contact: "Contact",
      schoolDescription: "School accredited by the Ministry of National Education (Preparatory - Primary - Intermediate)",
      home: "Home",
      test: "Test",
      courses: "levels",
      about_us: "About Us",
      contact_us: "Sign Up",
      sign_up: "Sign Up",
      sign_in: "Sign In",
      titleTS: "Welcome to Tissoura Private School",
      welcome_message: "Welcome to our private school TISSOURA, dedicated to providing quality education to students of three levels [Preschool, Primary, Middle], with a commitment to academic excellence, a nurturing environment, and stimulating educational programs. Our school aims to nurture each student's potential at every stage of their development.",
      explore_message: "Join us on an enriching educational journey, where learning, creativity, and personal growth are at the heart of our mission.",
      preschool_level: "Preschool Level",
      preschool_description: "Our preschool is a joyful place where little ones discover, play, and grow. Caring teachers guide them through fun activities that foster social, emotional, and intellectual development. Here, every day is a small adventure in learning to prepare children for their educational journey.",
      primary_level: "Primary Level",
      primary_description: "In the primary level of our TISSOURA school, each classroom is a dynamic learning hub. Our dedicated teachers create an environment where curiosity is awakened, friendships are forged, and knowledge comes to life. Through stimulating projects and interactive activities, we encourage our students to develop the fundamental skills they need. Together, we shape an exciting educational path that prepares our students for a bright future.",
      middle_level: "Middle Level",
      middle_description: "In the middle level, each student is invited to engage in a dynamic educational journey. Classrooms become spaces of discovery, where critical thinking is encouraged, and academic challenges are met with determination. Our dedicated teachers guide our students toward intellectual independence while cultivating an environment where learning goes beyond textbooks.",
      offers_title: "Training, Language Learning, Games",
      soroban_title: "Soroban",
      soroban_description: "Soroban: Develop cognitive skills through mental calculation with the soroban.",
      languages_title: "Language Learning",
      languages_description: "Language Learning: Enrich your language skills with language courses for all ages.",
      games_title: "Educational Games",
      games_description: "Educational Games: Enjoy learning through fun and interactive educational games.",
      programming: "Programming",
      programming_intro: "We introduce children to programming using modern tools like the micro:bit to develop their creativity and digital skills",
      quality_title: "Quality Education",
      quality_description: "Our commitment to providing a high-quality education to students in TISSOURA is based on a holistic approach. We foster the development of each student through stimulating programs, personalized attention, and a nurturing environment.",
      administration_title: "Administration",
      administration_description1: "We are committed to fostering an environment conducive to learning and growth.",
      administration_description2: "We are committed to fostering an environment conducive to learning and growth. Our administrative team ensures the smooth functioning of our institution and the well-being of each student. Feel free to contact us for any questions or additional information. ",
      administration_description3: "Feel free to contact us for any questions or additional information.",
      your_email: "Your Email",
      your_message: "Your Message",
      send_message: "Send Message",
      all_rights_reserved: "All rights reserved.",
      ourSchool: "Our School",
      ourSchoolDescription: "We take pride in our famous teaching traditions & achievements.",
      whyChooseUs: "Why Choose Us?",
      whyChooseUsDescription: "Our school is recognized for its excellence in educating young people.",
      activities: "Activities",
      activitiesDescription: "We have arranged a wide range of activities for our students.",
      certifications: "Certifications",
      certificationsDescription: "We take pride in our reputation for excellence in science, reflecting our ongoing commitment to providing high-quality education.",
      reputation: "Reputation",
      reputationDescription: "We have a good reputation for friendly teaching & learning environment.",
      library: "Library",
      libraryDescription: "We have the most modern library for the referencing needs of students.",
      learnMore: "LEARN MORE",
      quran_learning_title: "Quran Learning",
      quran_learning_description: "Give yourself the opportunity to learn the Quran with our programs tailored for all levels.",
      writing_improvement_title: "Writing Improvement",
      writing_improvement_description: "Enhance your writing skills with specialized courses and practical exercises.",
      school_title: "Private School Approved by the State [Preschool - Primary - Middle]",
      school_in:"[Preschool - Primary - Middle]",
      photo_gallery: "Photo Gallery",
      video_gallery: "Video Gallery",
      behavior: "Behavior",   
      add : "Add",
      class: "Class",
      Subject: "Subject",
      activityType: "Activity Type",
      assignedDate: "Assigned Date",
      dueDate: "Due Date",
      description: "Description",
      activityList: "Activity List",
      addActivity: "Add Activity",
      Homework: "Homework",
      Extracurricular: "Extracurricular",
      editActivity: "Edit an activity",
      ActivityFollowUp: "Activity Follow-up",
      StudentList: "Student List",
      fraudulent: "Fraudulent",
      completed: "Completed",
      incompleted: "Incompleted",
      pending: " Pending",
      absent : " Absent",
      dataRetrieval: "Retrieving data ...",
      dataRetrievalError: "Error retrieving data",
      activityFollowUpHistory: "Follow-up of students' homework for the ",
      verificationDate: "Verification Date",
      numberOfStudents: "Number of Students",
      student: "Student",
      followUp: "Follow-Up",
      date: "Date",
      retrievingClassesAndSubjects: "Retrieving classes and subjects",
      operationInProgress: "Operation in progress ...",
      activitySaved: "The Activity has been saved successfully",
      activitySaveError: "Error saving activity",
      activityDelition : "The Activity has been successfully deleted",
      activityDelitionError : "Error deleting activity",
      activityModified: "Activity has been modified successfully",
      activityModificationError: "Error modifying activity",
      statusModified: "Status has been modified successfully",
      modificationError: "Error saving changes",
      followUpDelition : "The Follow-up has been successfully deleted",
      followUpDelitionError : "Error deleting follow-up",
      error_follow_add: "Error while adding follow-up",
      followUpDetails: "Follow-Up Details",
      noDataAvailable: "No data available",
      noFollowUpsFound: "No follow-ups found.",
      consult_follow_ups: "Consult follow-ups",
      search_follow_ups_class: "Search follow-ups for a class",
      from_date: "From",
      to_date: "To",
      search_button: "Search",
      Tissoura_Private_School : "Tissoura Private School",
      emptyFollowUpList: "The follow-up list is empty",
      note: "Note",
      homework_completed: " Homework completed",
      preparation_without_effort: " Preparation without effort",
      preparation_not_done: " Preparation not done",
      director: "Director",
      school_administrator: "School administrator",
      cycle_responsible: "Cycle responsible",
      Select : "Select",
      searchStudentListForClass : "Search for the student list for a class",
      Teacher : "The teacher ",
      academic_level: "Academic level",
      administrative_discipline: "Administrative discipline",
      revision_and_memorization: "Revision and memorization",
      excellent_student: " : Excellent student",
      average_student: " : Average student",
      weak_student: " : Weak student",
      evaluateStudents : "Evaluate Students",
      studentEvaluationInfo : "Student Evaluation Information",
      evaluationType : "Evaluation Type",
      evaluationSavedSuccess: "The evaluation has been saved successfully",
      evaluationSaveError: "Error occurred while saving the evaluation",
      ViewEvaluation : "View evaluation",
      searchEvaluationResultsForClass: "Search for evaluation results for a class",
      empty_evaluation_list: "The evaluation list is empty",
      evaluationModifiedSuccess: "The evaluation has been successfully modified",
      evaluationDeletedSuccess: "The evaluation was successfully deleted",
      evaluationDeleteError: "Error while deleting the evaluation",
      studentStatistics: "Student Statistics",
      searchStudentStatisticsInPeriod: "Search for student statistics in a defined period",
      supportClasses: "Support classes",
      supportClassesList: "Support classes list",
      addSupportClass: "Add support class",
      supportClassRecorded: "Support class successfully recorded",
      supportClassRecordError: "Error while recording support class",
      supportClassDeleted: "Support class deleted successfully",
      supportClassDeleteError: "Error while deleting support class",
      editSupportClass: "Edit support class",
      supportClassEdited: "Support class successfully edited",
      supportClassEditError: "Error while editing support class",
      supportClassFollowUp: "Support class follow-up",
      understandingLesson: "Understanding the lesson",
      understandingExercise: "Understanding the exercise",
      supportLessonFollowUp: "Support lesson follow-up for students",
      lessonOrExerciseUnderstood: "Lesson or exercise understood",
      lessonOrExerciseNotUnderstood: "Lesson or exercise not understood",
      notConfirmedWithStudent: "Not confirmed with student",
      studentReport: "Student Report",
      subjects: "Subjects",
      Activities: "Activities",
      weeks: "Weeks",
      percentage: "Percentage",
      studentProgressCurve: "Student Progress Curve",
      meeting_form: "Meeting Form",
      parent_teacher_meeting_form: "Parent-Teacher Meeting Form",
      time: "Time",
      purpose_of_meeting: "purpose of the meeting",
      Scheduled: "Scheduled",
      IN_PROGRESS: "In Progress",
      Completed: "Completed",
      Cancelled: "Cancelled",
      Canceled: "Cancelled",
      Rescheduled: "Rescheduled",
      meeting_saved_successfully: "The meeting was saved successfully",
      error_saving_meeting: "Error while saving the meeting",
      Recruitment: "Recruitment",
      JobList: "Job List",
      applicationDeadline: "Application Deadline",
      page: "Page",
      department: "Department",
      jobRequirements: "Job Requirements",
      salaryRange: "Salary Range",
      jobOpened: "Job Opened",
      jobClosed: "Job Closed",
      addJob: "Add Job",
      jobTitle: "Job Title",
      editJob: "Edit Job",
      candidateList: "Candidate List",
      coverLetter: "Cover Letter",
      interviewList: "Interview List",
      appointment: "Interview Date",
      location: "Location",
      notes: "Notes",
      addInterview: "Add Interview",
      interviewSavedSuccess: "Interview saved successfully",
      interviewSaveError: "Error while saving the interview",
      edit_interview: "Edit Interview",
      edit_interview_success: "The interview was successfully edited",
      edit_interview_error: "Error while editing the interview",
      Meetings: "Meetings",
      listOfMeetings: "Meeting List",
      parent: "Parent",
      Phase1: "Phase 1",
      Phase2: "Phase 2",
      Phase3: "Phase 3",
      send_email: "Send the email",
      new_message: "New message",
      email_sent_success: "The email was sent successfully",
      email_sent_error: "Error while sending the email",
      meeting_updated_successfully: "The meeting has been successfully updated",
      error_updating_meeting: "An error occurred while updating the meeting",
      meeting_deleted_successfully: "The meeting has been successfully deleted",
      error_deleting_meeting: " Error while deleting the meeting",
      email_saved_success: "The email was successfully saved",
      email_saved_error: "Error while saving the email",
      sendEmails: "Send Emails",
      score: "The score",
      accepted_candidates_list: "The list of accepted candidates for the job",
      empty_candidates_list: "The list of accepted candidates is empty",
      organizations: "Organizations",
      institutions: "Institutions",
      levels: "Levels",
      classes: "Classes",
      teachers: "Teachers",
      payments: "Payments",
      products: "Products",
      enrollments: "Enrollments",
      schedules: "Schedules",
      attendances: "Attendances",
      tickets: "Tickets",
      abilities: "Abilities",
      my_account: "My Account",
      parents: "Parents",
      positions: "Positions",
      employees: "Employees",
      schooling: "Schooling",
      organizationManagement: "Organization Management",
      createOrganization: "Create Organization",
      organizationName: "Organization Name",
      mainUrl: "Main URL",
      directorName: "Director Name",
      coDirectorName: "Co-Director Name",
      userManagement: "User Management",
      createUser: "Create User",
      organizationDetails: "Organization Details",
      newDirectorDetails: "New Director Details",
      editOrganization: "Edit Organization",
      addOrganization: "Add Organization",
      cancel: "Cancel",
      institutionManagement: "Institution Management",
      createInstitution: "Create Institution",
      institutionName: "Institution Name",
      phones: "Phones",
      managerName: "Manager Name",
      editInstitution: "Edit Institution",
      addInstitution: "Add Institution",
      AddPhone: "Add Phone",
      Remove: "Remove",
      studentManagement: "Student Management",
      createStudent: "Create Student",
      studentName: "Student Name",
      gradeLevel: "Grade Level",
      parentName: "Parent Name",
      relationshipToParent: "Relationship to Parent",
      organizationFullName: "Organization Full Name",
      addStudent: "Add Student",
      Active: "Active",
      Inactive: "Inactive",
      Pending: "Pending",
      User: "User",
      Level: "Level",
      Institution: "Institution",
      classManagement: "Class Management",
      createClass: "Create Class",
      className: "Class Name",
      level: "Level",
      service: "Service",
      startDate: "Start Date",
      endDate: "End Date",
      schoolYearT: "School Year",
      unitPrice: "Unit Price",
      unitCount: "Unit Count",
      subjectManagement: "Subject Management",
      createSubject: "Create Subject",
      subjectName: "Subject Name",
      organization: "Organization",
      addSubject: "Add Subject",
      addClass: "Add Class",
      dateOfBirth: "Date of Birth",
      Technology: "Technology",
      Healthcare: "Healthcare",
      Finance: "Finance",
      Retail: "Retail",
      Education: "Education",
      PrivateSchool: "Private School",
      School: "School",
      Ecommerce: "Ecommerce",
      Petzeria: "Petzeria",
      Restaurant: "Restaurant",
      industry: "Industry",
      AddDirector: "Add Director",
      Director: "Director",
      institutionFullName: "Institution Full Name",
      Partners: "Partners",
      manager: "Manager",
      addManager: "Add Manager",
      NewManagerDetails: "New Manager Details",
      AddNewStudent: "Add New Student",
      parentManagement: "Parent Management",
      createParent: "Create Parent",
      addParent: "Add Parent",
      ParentInformation: "Parent Information",
      AddNewParent: "Add New Parent",
      SelectParent: "Select Parent",
      ChildrenInformation: "Children Information",
      SelectChild: "Select Child",
      Relationship: "Relationship",
      Mother: "Mother",
      Father: "Father",
      Guardian: "Guardian",
      Stepmother: "Stepmother",
      Stepfather: "Stepfather",
      Grandparent: "Grandparent",
      Other: "Other",
      AddChild: "Add Child",
      teacherManagement: "Teacher Management",
      createTeacher: "Create Teacher",
      subjectsTaught: "Subjects Taught",
      addTeacher: "Add Teacher",
      levelManagement: "Level Management",
      createLevel: "Create Level",
      levelName: "Level Name",
      type: "Type",
      editLevel: "Edit Level",
      editParent: "Edit Parent",
      editClass: "Edit Class",
      editSubject: "Edit Subject",
      editTeacher: "Edit Teacher",
      editStudent: "Edit Student",
      editUser: "Edit User",
      PreInvoiceDetails: "Pre Invoice",
      Invoices: "Invoices",
      paymentManagement: "Payment Management",
      createPayment: "Create Payment",
      invoice: "Invoice",
      paymentDate: "Payment Date",
      amount: "Amount",
      addPayment: "Add Payment",
      editPayment: "Edit Payment",
      preInvoiceDManagement: "Gestion des pré-factures",
      createPreInvoiceD: "Créer une pré-facture",
      item: "Article",
      total: "Total",
      consumedCount: "Quantité consommée",
      editPreInvoiceD: "Modifier la pré-facture",
      addPreInvoiceD: "Ajouter une pré-facture",
      invoiceManagement: "Invoice Management",
      createInvoice: "Create Invoice",
      editInvoice: "Edit Invoice",
      addInvoice: "Add Invoice",
      DateIssued: "Date Issued",
      InvoiceDetails: "Invoice Details",
      Discount: "Discount",
      NetAmount: "Net Amount",
      AddItem: "Add Item",
      InstallmentCount: "Installment Count",
      TotalAmount: "Total Amount",
      Unpaid: "Unpaid",
      Paid: "Paid",
      Overdue: "Overdue",
      SelectItem: "Select Item",
      addLevel: "Add Level",
      Regular: "Regular",
      Support: "Support",
      Training: "Training",
      employeeManagement: "Employee Management",
      createEmployee: "Create Employee",
      editEmployee: "Edit Employee",
      addEmployee: "Add Employee",
      position: "Position",
      salary: "Salary",
      benefits: "Benefits",
      contractDocument: "Contract Document",
      employeeName: "Employee Name",
      positionTitle: "Position Title",
      serviceManagement: "Service Management",
      createService: "Create Service",
      editService: "Edit Service",
      addService: "Add Service",
      ServiceCode: "Service Code",
      ServiceName: "Service Name",
      DefaultUnitPrice: "Default Unit Price",
      Available: "Available",
      Unavailable: "Unavailable",
      DefaultUnitCount: "Default Unit Count",
      productManagement: "Gestion des produits",
      createProduct: "Créer un produit",
      editProduct: "Modifier le produit",
      addProduct: "Ajouter un produit",
      ProductName: "Nom du produit",
      enrollmentManagement: "Enrollment Management",
      createEnrollment: "Create Enrollment",
      editEnrollment: "Edit Enrollment",
      addEnrollment: "Add Enrollment",
      Enrolled: "Enrolled",
      Dropped: "Dropped",
      EnrollmentDate: "Enrollment Date",
      scheduleManagement: "Schedule Management",
      createSchedule: "Create Schedule",
      editSchedule: "Edit Schedule",
      addSchedule: "Add Schedule",
      HourVolume: "Hour Volume",
      DayOfWeek: "Day of Week",
      StartTime: "Start Time",
      EndTime: "End Time",
      Location: "Location",
      attendanceManagement: "Attendance Management",
      createAttendance: "Create Attendance",
      editAttendance: "Edit Attendance",
      addAttendance: "Add Attendance",
      Schedule: "Schedule",
      Date: "Date",
      InReview: "In Review",
      Reviewed: "Reviewed",
      Approved: "Approved",
      Reported: "Reported",
      AttendanceStatus: "Attendance Status",
      Present: "Present",
      Absent: "Absent",
      Late: "Late",
      AddStudent: "Add Student",
      studentAttendance: "Student Attendance",
      teacherAttendance: "Teacher Attendance",
      ticketManagement: "Ticket Management",
      createTicket: "Create Ticket",
      addTicket: "Add Ticket",
      editTicket: "Edit Ticket",
      title2: "Title",
      OPEN: "Open",
      CLOSED: "Closed",
      Priority: "Priority",
      low: "Low",
      medium: "Medium",
      high: "High",
      Comments: "Comments",
      AddComment: "Add Comment",
      Attachments: "Attachments",
      AddAttachment: "Add Attachment",
      assignee: "Assignee",
      abilitiesManagement: "Abilities Management",
      createAbility: "Create Ability",
      resetAbilities: "Reset Abilities",
      deleteAbilities: "Delete Abilities",
      updateAbilities: "Update Abilities",
      cloneAbilities: "Clone Abilities",
      roleName: "Role Name",
      origin: "Origin",
      abilitiesCount: "Abilities Count",
      NewRoleName: "New Role Name",
      Manage: "Manage",
      Create: "Create",
      Read: "Read",
      Update: "Update",
      Delete: "Delete",
      Documents: "Documents",
      notificationSettings: "Notification Settings",
      enabled: "Enabled",
      disabled: "Disabled",
      emailNotifications: "Email Notifications",
      pushNotifications: "Push Notifications",
      appearanceSettings: "Appearance Settings",
      languageSettings: "Language Settings",
      language: "Language",
      french: "French",
      english: "English",
      arabic: "Arabic",
      additionalSettings: "Additional Settings",
      otherSettings: "Other Settings",
      AccountStatus: "Account Status",
      saveChanges: "Save Changes",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      updatePassword: "Update Password",
      Title: "Title",
      AddManager: "Add Manager",
      newRoleName: "New Role Name",
      reloadData: "Reload Data",
      SearchStudents: "Search Students",
      writing_training: "Writing Training",
      english_training: "English Training",
      quran_training: "Quran Training",
      teacher: "Teacher",
      all: "All",
      read: "Read",
      not_read: "NotRead",
      filter_by_status: "Filter by status",
      grades: "Grades",
      assignment: "Assignment",
      exam: "Test",
      exercise_count: "Number of exercises",
      assignment_points: "Assignment notes in the ",
      exercise_point: "Exercise note",
      activity_evaluation_rate: "Activity Evaluation Rate",
      grades2: "Grades",
      exercise: "Exercise",
      integration_status: "Final exercise",
      points: "Grades",
      product: "Product",
      payment_received: "Payment receipt",
      period: "Period",
      payment: "Payment",
      remaining_balance: "Remaining balance",
      total_amount: "Total Amount",
      total_payment_received: "Total payment received",
      filter_payment_receipts: "Filter payment receipts",
      student_in_period: "student in a period",
      user_in_period: "user in a period",
      NewDirectorDetails: "New Director Details",
      print: "Print",
      positionManagement: "Position Management",
      filledPositions: "Filled Positions",
      authorizedPositions: "Authorized Positions",
      createPosition: "Create Position",
      editPosition: "Edit Position",
      addPosition: "Add Position",
      by: "by",
      filterInvoices: "Filter invoices",
      message_sent_success: "The message has been sent successfully",
      message_sent_error: "Error while sending the message",
      select_organization: "Select an organization",
      select_institution: "Select an institution",
      select_class: "Select a class",
      listIsEmpty: "The list is empty",
      myChildren: "My children",
      Remedial: "Remedial",
      comments: "comments",
      attachments: "attachments",
      Browse: "Browse",
      Filename: "Filename",
      Comment: "Comment",
      addRole: "Add Role",
      Parameters: "Parameters",
      roleName: "Role Name",
      Role: "Role",
      editRole: "Edit Role",
      userRole: "User Roles",
      statistics: "Statistics",
      operationSuccessful: "Operation successful!",
      confirmDelete: "Confirm Deletion",
      areYouSureYouWantToDelete: "Are you sure you want to delete?",
      delete: "Delete",
      algerianDemocraticRepublic: "People's Democratic Republic of Algeria",
      ministryOfEducation: "Ministry of National Education",
      educationDirectorateTlemcen: "Directorate of Education for Tlemcen Province",
      schoolYear: "School Year",
      tissouraMansoura: "Tissoura Private School-Mansoura-",
      number: "Number : ",
      schoolCertificate: "School Certificate",
      certificateDirectorStatement: "The principal of the institution certifies that the student : ",
      certificateBirthInfo: "born on : ",
      certificateStudyStatus: "is continuing their studies",
      registrationNumber: "Registration number :",
      issuedInMansoura: "Issued in Mansourah on :",
      previousNameAndSurnameWriting: "Previous writing of the name and surname",
      schoolDirector: "School director",
      tissouraPrivateSchool: "Tissoura Private School",
      educational_group: "Educational group",
      issued_by: "Issued by",
      mansoura: "Mansourah",
      school_id_number: "School identification number",
      exit_date: "Exit Date",
      to_this_day: "To this day",
      newPassword: "New password",
      resetPassword: "Reset password",
      student_exit_log: "Exit Log",
      logout_record: "Exit Log",
      teacher_schedule: "Teacher Schedule",
      class_schedule: "Class Schedule",
      print_teacher_schedule: "Print Teacher Schedule",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      teacher_schedule : "Teacher's schedule",
      placeOfBirth: "Place of birth",
      location: "In",
      number_of_minutes: "Number of minutes",
      due_date: "Due date",
      guide_title: "Guide for the 'Students' Module",
      add_student: "Add a New Student",
      modify_student: "Modify a Student's Information",
      step1: "Log in to the application.",
      step2: "Go to the 'Students' module from the main menu.",
      step3: "Click the 'Add a student' button.",
      step4: "Fill in the required information (user, level, Institution, etc.).",
      step5: "Click 'Save' to add the student.",
      edit_student_info: "To edit the student's information, click on",
      save_student_info: "Click 'Save' to save the student's information",
      user_not_found: "If you don't find the user in the list, click on 'Add New Student'",
      fill_save_info: "Fill in the required information, then click 'Save'",
      generate_school_certificate: "To generate a school certificate, click on",
      classes_guide: "Guide for the 'Classes' Module",
      add_new_class: "Add a New Class",
      navigate_to_classes: "Navigate to the 'Schooling' module from the main menu.",
      click_add_class: "Click on the Add Class button",
      fill_required_info_c: "Fill in the required information (Class Name, Level, School Year, etc.)",
      click_save_class: "Click 'Save' to add the class",
      click_save_edit_class: "Click 'Save' to save the class",
      click_save_class_info: "Click 'Save' to save the class information",
      edit_class_info: "Edit class information",
      click_edit_class_info: "To edit class information, click on",
      registration_procedure: "Registration Protocol",
      prepare_data: "Data Preparation",
      prepare_student: "If the student is not yet created, create them by following the 'Students Guide'.",
      prepare_class: "If the class does not exist, create it by following the 'Classes Guide'.",
      access_registration: "Access the Registration Module",
      select_registration_module: "From the main menu, select the 'Registrations' module.",
      create_registration: "Create a New Registration",
      click_create_registration: "Click on the 'Create Registration' button.",
      fill_registration_info: "Fill in the required information",
      registration_details: "Select and enter the following details: Student, Class, Registration Date, Institution, Status.",
      save_registration: "Save the Registration",
      click_save_registration: "Click the 'Save' button to confirm the registration.",
      see_guide: "See guide",
      activities_unit_guide: "Activities Unit Guide",
      add_new_activity: "Add a new activity",
      go_to_students_unit: "Go to the 'Students' unit from the main menu",
      fill_required_information: "Fill in the required information (subject, section, description, etc.)",
      go_to_activities_unit: "Go to the 'Activities' unit from the secondary menu",
      click_add_button: "Click on the Add button",
      click_save_to_add_activity: "Click on 'Save' to add the activity",
      module_description: "This module tracks activities assigned to students, allowing the addition, management, and monitoring of each activity, while enabling smooth navigation between the 'Activities' and 'Students' units.",
      edit_activity_information: "Edit activity information",
      to_edit_activity_information_click_on: "To edit activity information, click on",
      click_save_to_save_activity: "Click on 'Save' to save the activity",
      to_add_follow_up_to_activity_click_on: "To add a follow-up to the activity, click on",
      to_view_activity_follow_ups_click_on: "To view activity follow-ups, click on",
      add_follow_up_to_activity: "Add a follow-up to the activity",
      to_view_follow_up_details_click_on: "To view follow-up details, click on",
      to_edit_follow_up_click_on: "To edit the follow-up, click on",
      to_delete_follow_up_click_on: "To delete the follow-up, click on",
      to_view_activity_follow_ups_for_section_in_period_click_on: "To view activity follow-ups for a section in a specific period, click on the 'View Follow-up' button",
      to_view_students_work_statistics_click_on: "To view students' work statistics, click on 'Students' Statistics'",
      to_view_specific_student_report_click_on: "To view a specific student's report, click on 'Student Report'",
      follow_up_protocol: "Activity Follow-Up Protocol",
      create_activity: "Create an Activity",
      create_follow_up: "Create one or more follow-ups for the activity",
      consult_follow_up: "Consult follow-ups in a specific period",
      support_lessons_guide: "Support Lessons 'Unit Guide'",
      navigate_support_lessons: "Navigate to the 'Support Lessons' unit from the secondary menu",
      save_support_lesson: "Click 'Save' to save the support lesson",
      add_support_lesson: "Add a support lesson",
      modify_support_lesson: "Modify Support Lesson",
      modify_support_lesson_info: "To modify the support lesson information, click on",
      click_save_to_save_support_lesson: "Click Save to save the support lesson",
      add_follow_up_to_support_lesson: "To add a follow-up to the support lesson, click on",
      view_follow_up_for_support_lesson: "To view the follow-up for the support lesson, click on",
      modify_and_save_follow_up: "You can modify the follow-up and then click Save",
      add_follow_up_to_support_lesson: "To add a follow-up to the support lesson, click on",
      view_follow_up_for_support_lesson: "To view the follow-up for the support lesson, click on",
      modify_and_save_follow_up: "You can modify the follow-up and then click Save",
      support_lesson_follow_up_module_description: "This module allows tracking of support lessons for students.",
      requests: "Requests",
      createRequest: "Create a request",
      filterRequset: "Filter requests",
      Pending: "Pending",
      Purchased: "Purchased",
      manage_requests: "Manage requests",
      editRequest: "Edit request",
      requestDetails: "Request details",
      notebookTracking: "Notebook tracking",
      addTracking: "Add tracking",
      trackingAddedSuccess: "Tracking added successfully",
      trackingUpdatedSuccess: "Tracking updated successfully",
      editTracking: "Modifier le suivi",
      lessonCompleted: "Lesson completed",
      lessonNotCompleted: "Lesson not completed",
      handwritingImprovement: "Handwriting improvement",
      inProgress: "In Progress",
      consult_follow_up_SC :"To view the follow-ups of support lessons for a section over a specific period, click on the 'View evaluation' button.",
      behavior_module_guide: "'Behavior' Module Guide ",
      behavior_module_description: "'This module allows monitoring students behavior",
      navigate_behavior_module: "Go to the Behavior 'module' from the side menu",
      click_evaluate_students: "Click on the 'Evaluate Students' button",
      fill_required_info: "Fill in the required information (subject, class, type of evaluation, etc.)",
      click_save: "Click on 'Save'",
      evaluate_each_student: "Evaluate each student according to their level (A, B, C)",
      view_evaluation: "To display the evaluation by subject and class for a specific period, click on 'View Evaluation'",
      notebook_tracking_guide: "'Notebook Tracking' Guide",
      notebook_tracking_description: "This module allows monitoring of students notebooks",
      navigate_notebook_tracking: "Go to the 'Notebook Tracking' module from the side menu",
      fill_required_info_notebook: "Fill in the required information (subject, class, institution, etc.)",
      click_on: "Click on",
      edit_tracking_info: "To edit the tracking information, click on",
      view_tracking_details: "To see the tracking details, click on",
      view_notebook_tracking: "To view the notebook tracking for a class within a specific period, click on the 'View Tracking' button (it can be filtered by subject)",
      meetings_module_guide: "'Meetings' Module Guide",
      meetings_module_description: "This module allows the management of meetings between teachers and parents.",
      navigate_meetings_module: "Go to the 'Meetings' module from the side menu.",
      add_meeting: "Add a meeting",
      click_meeting_form: "Click on the meeting form",
      fill_meeting_info: "Fill in the required information: teacher, parent, date, etc.",
      edit_meeting_info: "To edit meeting details, click on",
      view_meeting_details: "To view meeting details, click on",
      support_course_tracking_protocol: "Support lesson tracking protocol",
      add_support_course: "Add support lesson",
      add_support_course_tracking: "Add support lesson tracking",
      view_support_course_tracking: "View support lesson tracking over a specific period (filtering by subject available)",
      add_notebook_tracking: "Add notebook tracking",
      add_tracking_details: "Add tracking details after reviewing students' notebooks",
      view_notebook_tracking_P: "View notebook tracking for a specific period (can be displayed by subject)",
      notebook_tracking_protocol: "Notebook tracking protocol",
      payroll: "Payroll",
      PayPeriod: "Pay Period",
      GrossPay: "Gross Pay",
      NetPay: "Net Pay",
      PaymentMethod: "Payment Mode",
      Employee: "Employee",
      payroll_management: "Payroll management",
      create_payroll: "Create payroll",
      add_payroll: "Add payroll",
      edit_payroll: "Edit payroll",
      MONTHLY: "Monthly",
      PER_SESSION: "Per session",
      Cash: "Cash",
      PERCENTAGE: "Percentage",
      module_guide_subjects: "Module Guide 'Subjects'",
      add_new_subject: "Add a new subject",
      navigate_to_subjects_module: "Navigate to the 'Subjects' module from the side menu",
      click_add_subject: "Click on the Add Subject button",
      click_save_to_add_subject: "Click 'Save' to add the subject",
      fill_required_information_s: "Fill in the required information (subject name, description, level, etc.)",
      edit_subject_information: "Edit subject information",
      click_to_edit_subject_information: "To edit the subject information, click on",
      click_save_to_save_subject: "Click 'Save' to save the subject",
      reports: "Reports",
      create_report: "Create report",
      manage_reports: "Manage reports",
      title: "Title",
      description: "Description",
      date_of_report: "Date of Report",
      file_url: "File URL",
      add_report: "Add Report",
      edit_report: "Edit Report",
      created_by: "Created By",
      canceled: "Canceled",
      print_payment_notice: "Print Notice",
      payment_notice_on: "Payment Notice on:",
      education_levels: "Preparatory - Primary - Intermediate",
      print_student_list: "Print Student List",
      number_of_sessions: "Number of Sessions",
      minutes: "Minutes",
      call_management: "Call Management",
      calls: "Calls",
      contact_list: "Contact List",
      course_schedule: "Course Schedule",
      print_course_schedule: "Print Course Schedule",
      day : "Day",
      timeS: "Time",
      phone_number: "Phone Number",
      remaining: "Remaining",
      levels_module_guide: "Levels Module Guide",
      add_new_level: "Add New Level",
      navigate_to_levels_module: "Navigate to the 'Levels' module from the side menu.",
      click_add_level: "Click on the Add Level button.",
      fill_required_level_information: "Fill in the required information (level name, description, etc.).",
      click_save_to_add_level: "Click 'Save' to add the level.",
      edit_level_information: "Edit level information",
      click_to_edit_level_information: "To edit the level information, click on",
      click_save_to_save_level: "Click 'Save' to save the level",
      create_subjects_if_not_available: "If subjects are not available, create them through the 'Subjects' guide.",
      enroll_students_in_classes: "Enroll students in classes",
      add_ability: "Add Ability",
      edit_ability: "Edit Ability",
      action: "Action",
      subject: "Subject",
      conditions_json: "Conditions (JSON)",
      updating: "Updating...",
      update_abilities: "Update Abilities",
      add_role: "Add Role",
      accounting: "Accounting",
      accounts: "Accounts",
      transaction_journal: "Transaction Journal",
      owner_name: "Owner Name",
      balance: "Balance",
      add_account: "Add Account",
      edit_account: "Edit Account",
      accounts_management: "Accounts Management",
      owner_type: "Account Owner Type",
      remaining_amount: "Remaining Amount",
      to_be_paid: "To Be Paid",
      pay_invoices: "Pay Invoices",
      refund_receipt: "Refund Receipt",
      refund: "Refund",
      observation: "Observation",
      signature: "Signature",
      and: "and",
      payment_statement: "Account statement",
      refund_date: "Refund Date",
      allClasses: "All classes",
      sessions : "Sess",
      week: "week",
      student_not_registered: "Student is not registered",
      hello: "Hello",
      json_export_error: "An error occurred while downloading JSON data.",
      add_industry: "Add Industry",
      edit_industry: "Edit Industry",
      upload_json_file: "Upload JSON file",
      selected_file: "Selected file:",
      json_file: "JSON file",
      choose_file: "Choose a file",
      please_select_a_file: "Please select a file",
      invalid_json_file: "Invalid JSON file!",
      Personal: "Personal",
      Editing: "Editing",
      validation_failed: "Validation failed: Please ensure all children fields are filled out.",
      approved_by_ministry: "Approved by the Ministry of Education",
      net: "Net",
      rc : "RC",
      nif : "NIF",
      emailInvoice : "EMAIL",
      invoice_journal: "Invoice Journal",
      totalInvoice: "Total", 
      agent_signature: "Agent's Signature",
      institution_stamp: "Institution Stamp",
      tel : "TEL",
      amount_in_words: "Amount in words",
      dzd: "Algerian Dinars",
      fb :'FB',
      client: "Client",
      payment_journal: "Payment Journal",
      until: "until",
      subTitle: "Subtitle",
      Confirmed: "Confirmed",
      Billed: "Billed",
      add_preinvoices: "Add Pre-invoices",
      schoolLevels: "School Levels",
      PRIMARY: "Primary School",
      MIDDLE: "Middle School",
      SECONDARY: "Secondary School",
      OTHER: "Other",
      category: "Category",
      TUITION: "Tuition",
      TRANSPORT: "Transport",
      CANTEEN: "Canteen",
      ACTIVITY: "Activity",
      print_pre_invoices: "Pre-invoices",
      pre_invoices: "Pre-invoices",
      defaultUnit: "Default unit",
      MONTH: "Month",
      WEEK: "Week",
      SEANCE: "Session",
      UNITLESS: "Unitless",
      all_services: "All services",
      pre_invoice: "Pre-invoice",
      transaction_journal: "Transaction Journal",
      number_of_registrations: "Number of registrations",
      ministry_platform: "Ministry Platform",
      black_list: "Black List",
      code_class: "Class Code",
      level_code: "Level Code",
      class_list: "Class List",
      totalS: "Total",
      verify_payment: "Verify Payment",
      Exited: "Transfer",
      archive: "Archive",
      maxStudents: "Maximum Students",
      minStudents: "Minimum Students",
      jobs: "Jobs",
      unregistered_ministry: "Students not registered in the Ministry platform",
      Archived: "Archived",
      Deleted: "Deleted",
      archiveStatus: "Archive Status",
      students_archive: "Students Archive",
      classes_archive: "Classes Archive",
      registrations_archive: "Enrollments Archive",
      jobsManagement: "Jobs Management",
      candidates: "Candidates",
      teachers_archive: "Teachers Archive",
      SPORT: "Sport",
      discountRate: "Discount Rate",
      with_preinvoice_creation: "With pre-invoice creation",
      without_preinvoice_creation: "Without pre-invoice creation",
      groups: "Groups",
      groups_management: "Groups Management",
      add_group: "Add Group",
      edit_group: "Edit Group",
      group_name: "Group Name",
      code_group: "Group Code",
      referred_by: "Recommended By",
      applicants: "Applicants",
      applicantsManagement: "Applicants Management",
      applicantName: "Applicant Name",
      createApplicant: "Create Applicant",
      editApplicant: "Edit Applicant",
      addNewApplicant: "Add New Applicant",
      preInvoice: "Pre-invoice",
      pendingClass: "Pending",
      ANNUAL: "Registration Fee",
      applications: "Job Applications",
      applicationManagement: "Application Management",
      createApplication: "Create Application",
      ApplicationDate: "Application Date",
      job: "Job",
      editApplication: "Edit Application",
      applicant: "Applicant",
      editInterview: "Edit Interview",
      createInterview : "Create Interview",
      AddTeacher: "Add Teacher",
      totalAbsent: "Total Absent",
      totalLate: "Total Late",
      totalPresent: "Total Present",
      dailyAttendanceReport: "Daily Attendance Report",
      justification: "Justification",
      MedicalCertificate: "Medical Certificate",
      None: "None",
      reason: "Reason",
      PreEnrolled: "Pre-enrolled",
      editRefund: "Edit Refund",
      mainList: "Main List",
      followUpList: "Follow-up List",
      creditStatus: "Credit Status",
      subscribers: "Subscribers",
      subscribersManagement: "Subscribers Management",
      annualFeeManagement: "Registartion Fee Management",
      PartiallyPaid: "Partially Paid",
      individualBilling: "Individual Billing",
      groupBilling: "Group Billing",
      interviewer: "Interviewer",
      humanResources: "Human Resources",
      registrationLog: "Registration Log",
      subscribersLog: "Subscribers Log",
      PHASE1: "Phase 1",
      PHASE2: "Phase 2",
      PHASE3: "Phase 3",
      PENDING: "Pending",
      ACCEPTED: "Accepted",
      REJECTED: "Rejected",
      UNDER_REVIEW: "Under Review",
      phase: "Phase",
      interviewResult: "Interview Result",
      interviewNotes: "Interview Notes",
      nis: "SIN"
    },
  },
  fr: {
    translation: {
      login: 'Se connecter',
      register:" S'inscrire",
      forgotPassword: 'Mot de passe oublié ?',
      resetPassword: 'Réinitialiser le mot de passe',
      emailPlaceholder: 'Entrez votre e-mail',
      usernamePlaceholder: "Entrez votre nom d'utilisateur",
      passwordPlaceholder: 'Entrez votre mot de passe',
      confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
      rememberPassword: 'Vous souvenez-vous de votre mot de passe ?',
      haveAccount: 'Vous avez déjà un compte ? Connectez-vous ici',
      noAccount: "Vous n'avez pas de compte ? Inscrivez-vous ici",
      tissouraLogoAlt: 'Logo Tissoura',
      dashboard: 'Tableau de bord',
      profile: 'Profil',
      statistics: 'Statistiques',
      messages: 'Messages',
      notifications: 'Notifications',
      settings: 'Réglages',
      user: 'utilisateur',
      users: 'Utilisateurs',
      firstName: 'Nom',
      lastName: 'Prénom',
      status: 'Statut',
      actions: 'Actions',
      details: 'Détails',
      edit: 'Modifier',
      delete: 'Supprimer',
      addUser: 'Ajouter un utilisateur',
      userDetails: "Détails de l'utilisateur",
      id: 'ID',
      email: 'Email',
      active: 'Actif',
      inactive: 'Inactif',
      save: 'Enregistrer',
      close: 'Fermer',
      name: "Nom",
      phone: "Téléphone",
      address: "Adresse",
      userPages: 'Pages utilisateur',
      search: 'Rechercher...',
      personalData: 'Données personnelles',
      role: 'Rôle',
      totalEmployees: "Total employés",
      totalTeachers: "Total enseignants",
      userGrowth: "Croissance des utilisateurs",
      students: "Étudiants",
      Employee: "Employé",
      documents: "Documents",
      logout: "Se déconnecter",
      welcomeTitle: "Bienvenue à Tissoura",
      welcomeDescription1: "À Tissoura, nous offrons une éducation de haute qualité pour favoriser la croissance et le développement de nos étudiants. Rejoignez-nous pour offrir à vos enfants le meilleur départ dans la vie.",
      welcomeDescription2: "Notre école comprend deux institutions : Tissoura Primaire et Tissoura CEM, chacune dédiée à fournir un enseignement exceptionnel à chaque étape de l'éducation de votre enfant.",
      servicesTitle: "Nos Services",
      servicesDescription: "Nous offrons une gamme de services éducatifs adaptés aux besoins de nos étudiants, y compris des plans d'apprentissage personnalisés, des activités extrascolaires et des installations à la pointe de la technologie.",
      contactTitle: "Contactez-nous",
      contactDescription: "Si vous avez des questions ou si vous souhaitez en savoir plus sur nos programmes, n'hésitez pas à nous contacter.",
      joinUsButton: "Rejoignez-nous maintenant",
      about: "À propos",
      services: "Services",
      contact: "Contact",
      schoolDescription: "École agréée par le ministère de l'Éducation nationale (Préparatoire - Primaire - Moyen)",
      home: "Accueil",
      test: "Test",
      courses: "niveaux",
      about_us: "À propos de nous",
      contact_us: "Inscrivez-vous",
      sign_up: "S'inscrire",
      sign_in: "Se connecter",
      titleTS: "Bienvenue à l'école privée Tissoura",
      welcome_message: "Bienvenue dans notre école privée TISSOURA, dédiée à fournir une éducation de qualité aux étudiants des trois niveaux [Préscolaire, Primaire, Moyen], avec un engagement envers l'excellence académique, un environnement chaleureux, et des programmes éducatifs stimulants. Notre école vise à développer le potentiel de chaque élève à chaque étape de leur développement.",
      explore_message: "Rejoignez-nous dans un parcours éducatif enrichissant, où l'apprentissage, la créativité, et la croissance personnelle sont au cœur de notre mission.",
      preschool_level: "Niveau Préscolaire",
      preschool_description: "Notre école maternelle est un lieu joyeux où les petits découvrent, jouent et grandissent. Des enseignants attentionnés les guident à travers des activités amusantes qui favorisent le développement social, émotionnel et intellectuel. Ici, chaque jour est une petite aventure d'apprentissage pour préparer les enfants à leur parcours éducatif.",
      primary_level: "Niveau Primaire",
      primary_description: "Au niveau primaire de notre école TISSOURA, chaque classe est un centre d'apprentissage dynamique. Nos enseignants dévoués créent un environnement où la curiosité est éveillée, les amitiés sont nouées et la connaissance prend vie. Grâce à des projets stimulants et des activités interactives, nous encourageons nos élèves à développer les compétences fondamentales dont ils ont besoin. Ensemble, nous façonnons un chemin éducatif excitant qui prépare nos étudiants à un avenir brillant.",
      middle_level: "Niveau Moyen",
      middle_description: "Au niveau moyen, chaque élève est invité à s'engager dans un parcours éducatif dynamique. Les salles de classe deviennent des espaces de découverte où la pensée critique est encouragée et les défis académiques sont relevés avec détermination. Nos enseignants dévoués guident nos élèves vers l'indépendance intellectuelle tout en cultivant un environnement où l'apprentissage va au-delà des manuels.",
      offers_title: "Formation, Apprentissage des Langues, Jeux",
      soroban_title: "Soroban",
      soroban_description: "Soroban: Développez vos compétences cognitives par le calcul mental avec le soroban.",
      languages_title: "Apprentissage des Langues",
      languages_description: "Apprentissage des Langues: Enrichissez vos compétences linguistiques avec des cours de langues pour tous les âges.",
      games_title: "Jeux Éducatifs",
      programming: "La programmation",
      programming_intro: "Nous initions les enfants à la programmation avec des outils modernes comme le micro:bit pour développer leur créativité et leurs compétences numériques",
      games_description: "Jeux Éducatifs: Apprenez en vous amusant avec des jeux éducatifs interactifs et amusants.",
      quality_title: "Éducation de Qualité",
      quality_description: "Notre engagement à fournir une éducation de haute qualité aux étudiants de TISSOURA repose sur une approche holistique. Nous favorisons le développement de chaque élève à travers des programmes stimulants, une attention personnalisée et un environnement chaleureux.",
      administration_title: "Administration",
      administration_description1: "Nous nous engageons à favoriser un environnement propice à l'apprentissage et à la croissance.",
      administration_description2: "Nous nous engageons à favoriser un environnement propice à l'apprentissage et à la croissance. Notre équipe administrative veille au bon fonctionnement de notre institution et au bien-être de chaque élève. N'hésitez pas à nous contacter pour toute question ou information supplémentaire.",
      administration_description3: "N'hésitez pas à nous contacter pour toute question ou information supplémentaire.",
      your_email: "Votre Email",
      your_message: "Votre Message",
      send_message: "Envoyer Message",
      all_rights_reserved: "Tous droits réservés.",
      ourSchool: "Notre École",
      ourSchoolDescription: "Nous sommes fiers de nos traditions et réalisations pédagogiques renommées.",
      whyChooseUs: "Pourquoi Nous Choisir?",
      whyChooseUsDescription: "Notre école est reconnue pour son excellence dans l'éducation des jeunes.",
      activities: "Activités",
      activitiesDescription: "Nous avons organisé une large gamme d'activités pour nos étudiants.",
      certifications: "Certifications",
      certificationsDescription: "Nous sommes fiers de notre réputation d'excellence en sciences, témoignant de notre engagement constant envers une éducation de haute qualité",
      reputation: "Réputation",
      reputationDescription: "Nous avons une bonne réputation pour un environnement d'enseignement et d'apprentissage amical.",
      library: "Bibliothèque",
      libraryDescription: "Nous avons la bibliothèque la plus moderne pour les besoins de référence des étudiants.",
      learnMore: "EN SAVOIR PLUS",
      quran_learning_title: "Apprentissage du Coran",
      quran_learning_description: "Offrez-vous la possibilité d'apprendre le Coran avec nos programmes adaptés à tous les niveaux.",
      writing_improvement_title: "Amélioration de l'écriture",
      writing_improvement_description: "Améliorez vos compétences en écriture grâce à des cours spécialisés et des exercices pratiques.",
      school_title: "École Privée Agréée Par L'état  [Préscolaire - Primaire - Moyen]",
      school_in:"[Préscolaire - Primaire - Moyen]",
      photo_gallery: "Galerie de photos",
      video_gallery: "Galerie de vidéos",
      behavior : "comportement",
      add:"Ajouter",
      class: "Classe",
      Subject: "Matière",
      activityType: "Type d'activité",
      assignedDate: "Date d'assignation",
      dueDate: "Date limite",
      description : "Description",
      activityList : "Liste des activités",
      addActivity: "Ajouter une activité",
      Homework: "Devoir",
      Extracurricular: "Parascolaire",
      editActivity: "Modifier une activité",
      ActivityFollowUp: "Suivi d'une activité",
      StudentList: "Liste des élèves",
      fraudulent: "Frauduleux",
      completed: "Terminé",
      incompleted: "Incomplet",
      pending: " En attente",
      absent : " Absent",
      dataRetrieval: "Récupération des données ...",
      dataRetrievalError: "Erreur lors de la récupération des données",
      activityFollowUpHistory: " Suivi des devoirs des élèves de ",
      verificationDate: "Date de vérification",
      numberOfStudents: "Nombre d'élèves",
      student: "élève",
      followUp: "Suivi",
      date: "Date",
      retrievingClassesAndSubjects: "Récupération des classes et matières",
      operationInProgress: "Opération en cours d'éxécution ...",
      activitySaved: "L'activité a été enregistrée avec succès",
      activitySaveError: "Erreur lors de l'enregistrement de l'activité",
      activityDelition : "L'activité a été supprimée avec succès",
      activityDelitionError : "Erreur lors de la suppression de l'activité",
      activityModified: "L'activité a été modifiée avec succès",
      activityModificationError: "Erreur lors de la modification de l'activité",
      statusModified: "Le statut a été modifié avec succès",
      modificationError: "Erreur lors de l'enregistrement des modifications",
      followUpDelition : "Le suivi a été supprimé avec succès",
      followUpDelitionError : "Erreur lors de la suppression du suivi",
      error_follow_add: "Erreur lors de l'ajout du suivi",
      followUpDetails : "Détails du suivi",
      noDataAvailable: "Aucune donnée disponible",
      noFollowUpsFound: "Aucun suivi trouvé.",
      consult_follow_ups: "Consulter les suivis",
      search_follow_ups_class: "Rechercher les suivis pour une classe",
      from_date: "Du",
      to_date: "Au",
      search_button: "Chercher",
      Tissoura_Private_School : "École Privée Tissoura",
      emptyFollowUpList: "La liste des suivis est vide",
      note: "Remarque",
      homework_completed: " Devoir terminé",
      preparation_without_effort: " Préparation sans effort",
      preparation_not_done: " Préparation non faite",
      director: "Directeur",
      school_administrator: "Gestionnaire de l'école",
      cycle_responsible: "Responsable de cycle",
      Select : "Sélectionner",
      searchStudentListForClass : "Rechercher la liste des élèves pour une classe",
      Teacher: "L'enseignant(e) ",
      academic_level: "Le niveau d'études",
      administrative_discipline: "La discipline administrative",
      revision_and_memorization: "La révision et la mémorisation",
      excellent_student: " : Élève excellent",
      average_student: " : Élève moyen",
      weak_student: " : Élève faible",
      evaluateStudents : "Évaluer les étudiants",
      studentEvaluationInfo : "Informations sur l'évaluation des élèves",
      evaluationType : "Type d'évaluation",
      evaluationSavedSuccess: "L'évaluation a été enregistrée avec succès",
      evaluationSaveError: "Erreur lors de l'enregistrement de l'évaluation",
      ViewEvaluation : "Consulter l'évaluation",
      searchEvaluationResultsForClass: "Rechercher les résultats de l'évaluation pour une classe",
      empty_evaluation_list: "La liste des évaluations est vide",
      evaluationModifiedSuccess: "L'évaluation a été modifiée avec succès",
      evaluationDeletedSuccess: "L'évaluation a été supprimée avec succès",
      evaluationDeleteError: "Erreur lors de la suppression de l'évaluation",
      studentStatistics: "Statistiques des élèves",
      searchStudentStatisticsInPeriod: "Rechercher des statistiques des élèves sur une période définie",
      supportClasses: "Cours de soutien",
      supportClassesList: "Liste des cours de soutien",
      addSupportClass: "Ajouter un cours de soutien",
      supportClassRecorded: "Cours de soutien enregistré avec succès",
      supportClassRecordError: "Erreur lors de l'enregistrement du cours de soutien",
      supportClassDeleted: "Cours de soutien supprimé avec succès",
      supportClassDeleteError: "Erreur lors de la suppression du cours de soutien",
      editSupportClass: "Modifier le cours de soutien",
      supportClassEdited: "Cours de soutien modifié avec succès",
      supportClassEditError: "Erreur lors de la modification du cours de soutien",
      supportClassFollowUp: "Suivi du cours de soutien",
      understandingLesson: "Compréhension de la leçon",
      understandingExercise: "Compréhension de l'exercice",
      supportLessonFollowUp: "Suivi des cours de soutien pour les élèves",
      lessonOrExerciseUnderstood: "Leçon ou exercice compris",
      lessonOrExerciseNotUnderstood: "Leçon ou exercice non compris",
      notConfirmedWithStudent: "Non confirmé avec l'élève",
      studentReport: "Rapport de l'élève",
      subjects: "Matières",
      Activities: "Activités",
      weeks: "Semaines",
      percentage: "Pourcentage",
      studentProgressCurve: "Courbe d'évolution de l'élève",
      meeting_form: "Formulaire de réunion",
      parent_teacher_meeting_form: "Formulaire de réunion parent-enseignant",
      time: "Heure",
      purpose_of_meeting: "but de la réunion",
      Scheduled: "Planifié",
      IN_PROGRESS: "En cours",
      Completed: "Terminé",
      Cancelled: "Annulé",
      Canceled: "Annulé",
      Rescheduled: "Replanifié",
      meeting_saved_successfully: "La réunion a été enregistrée avec succès",
      error_saving_meeting: "Erreur lors de l'enregistrement de la réunion",
      Recruitment: "Recrutement",
      JobList: "Liste des postes",
      applicationDeadline: "Date limite de candidature",
      page :"Page",
      department: "Département",
      jobRequirements: "Exigences du poste",
      salaryRange: "Plage salariale",
      jobOpened: "Poste ouvert",
      jobClosed: "Poste fermé",
      addJob: "Ajouter un poste",
      jobTitle: "Intitulé du poste",
      editJob: "Modifier le poste",
      candidateList: "Liste des candidats",
      coverLetter: "Lettre de motivation",
      interviewList: "Liste des entretiens",
      appointment: "Date de l'entretien",
      location: "Emplacement",
      notes: "Notes",
      addInterview: "Ajouter un entretien",
      interviewSavedSuccess: "Entretien enregistré avec succès",
      interviewSaveError: "Erreur lors de l'enregistrement de l'entretien",
      edit_interview: "Modification de l'entretien",
      edit_interview_success: "L'entretien a été modifié avec succès",
      edit_interview_error: "Erreur lors de la modification de l'entretien",
      Meetings: "Réunions",
      listOfMeetings: "Liste des réunions",
      parent: "Parent",
      Phase1: "Phase 1",
      Phase2: "Phase 2",
      Phase3: "Phase 3",
      send_email: "Envoyer l'email",
      new_message: "Nouveau message",
      email_sent_success: "L'email a été envoyé avec succès",
      email_sent_error: "Erreur lors de l'envoi de l'email",
      meeting_updated_successfully: "La réunion a été modifiée avec succès",
      error_updating_meeting: "Erreur lors de la modification de la réunion",
      meeting_deleted_successfully: "L'assemblée a été supprimée avec succès",
      error_deleting_meeting: "Erreur lors de la suppression de la réunion",
      email_saved_success: "L'e-mail a été enregistré avec succès",
      email_saved_error: "Erreur lors de l'enregistrement de l'e-mail",
      sendEmails: "Envoyer les emails",
      score: "La note",
      accepted_candidates_list: "La liste de candidats acceptés pour le poste",
      empty_candidates_list:  "La liste des candidats acceptés est vide",
      organizations: "Organisations",
      institutions: "Institutions",
      levels: "Niveaux",
      classes: "Classes",
      teachers: "Enseignants",
      payments: "Paiements",
      products: "Produits",
      enrollments: "Inscriptions",
      schedules: "Horaires",
      attendances: "Présences",
      tickets: "Tickets",
      abilities: "Permissions",
      my_account: "Mon Compte",
      parents: "Parents",
      positions: "Postes",
      employees: "Employés",
      schooling: "Scolarité",
      organizationManagement: "Gestion des organisations",
      createOrganization: "Créer une organisation",
      organizationName: "Nom de l'organisation",
      mainUrl: "URL principale",
      directorName: "Nom du directeur",
      coDirectorName: "Nom du codirecteur",
      userManagement: "Gestion des utilisateurs",
      createUser: "Créer un utilisateur",
      organizationDetails: "Détails de l'organisation",
      newDirectorDetails: "Détails du nouveau directeur",
      editOrganization: "Modifier l'organisation",
      addOrganization: "Ajouter une organisation",
      cancel: "Annuler",
      institutionManagement: "Gestion des institutions",
      createInstitution: "Créer une institution",
      institutionName: "Nom de l'institution",
      phones: "Téléphones",
      managerName: "Nom du gestionnaire",
      editInstitution: "Modifier l'institution",
      addInstitution: "Ajouter une institution",
      AddPhone: "Ajouter un téléphone",
      Remove: "Supprimer",
      studentManagement: "Gestion des élèves",
      createStudent: "Créer un élève",
      studentName: "Nom de l'élève",
      gradeLevel: "Niveau scolaire",
      parentName: "Nom du parent",
      relationshipToParent: "Relation avec le parent",
      organizationFullName: "Nom complet de l'organisation",
      addStudent: "Ajouter un élève",
      Active: "Actif",
      Inactive: "Inactif",
      Pending: "En attente",
      User: "Utilisateur",
      Level: "Niveau",
      Institution: "Institution",
      classManagement: "Gestion des classes",
      createClass: "Créer une classe",
      className: "Nom de la classe",
      level: "Niveau",
      service: "Service",
      startDate: "Date de début",
      endDate: "Date de fin",
      schoolYearT: "Année scolaire",
      unitPrice: "Prix unitaire",
      unitCount: "Nombre d'unités",
      subjectManagement: "Gestion des matières",
      createSubject: "Créer une matière",
      subjectName: "Nom de la matière",
      organization: "Organisation",
      addSubject: "Ajouter une matière",
      addClass: "Ajouter une classe",
      dateOfBirth: "Date de naissance",
      Technology: "Technologie",
      Healthcare: "Soins de santé",
      Finance: "Finance",
      Retail: "Vente au détail",
      Education: "Éducation",
      PrivateSchool: "École privée",
      School: "École",
      Ecommerce: "Commerce en ligne",
      Petzeria: "Petzeria",
      Restaurant: "Restaurant",
      industry: "Industrie",
      AddDirector: "Ajouter un directeur",
      Director: "Directeur",
      institutionFullName: "Nom complet de l'institution",
      Partners: "Partenaires",
      manager: "Gestionnaire",
      addManager: "Ajouter un gestionnaire",
      NewManagerDetails: "Détails du nouveau gestionnaire",
      AddNewStudent: "Ajouter un nouvel élève",
      parentManagement: "Gestion des parents",
      createParent: "Créer un parent",
      addParent: "Ajouter un parent",
      ParentInformation: "Informations sur les parents",
      AddNewParent: "Ajouter un nouveau parent",
      SelectParent: "Sélectionner un parent",
      ChildrenInformation: "Informations sur les enfants",
      SelectChild: "Sélectionner un enfant",
      Relationship: "Relation",
      Mother: "Mère",
      Father: "Père",
      Guardian: "Tuteur",
      Stepmother: "Belle-mère",
      Stepfather: "Beau-père",
      Grandparent: "Grand-parent",
      Other: "Autre",
      AddChild: "Ajouter un enfant",
      teacherManagement: "Gestion des enseignants",
      createTeacher: "Créer un enseignant",
      subjectsTaught: "Matières enseignées",
      addTeacher: "Ajouter un enseignant",
      levelManagement: "Gestion des niveaux",
      createLevel: "Créer un niveau",
      levelName: "Nom du niveau",
      type: "Type",
      editLevel: "Modifier le niveau",
      editParent: "Modifier le parent",
      editClass: "Modifier la classe",
      editSubject: "Modifier la matière",
      editTeacher: "Modifier l'enseignant",
      editStudent: "Modifier l'élève",
      editUser: "Modifier l'utilisateur",
      PreInvoiceDetails: "Pré-facture",
      Invoices: "Factures",
      paymentManagement: "Gestion des paiements",
      createPayment: "Créer un paiement",
      invoice: "Facture",
      paymentDate: "Date de paiement",
      amount: "Montant",
      addPayment: "Ajouter un paiement",
      editPayment: "Modifier un paiement",
      preInvoiceDManagement: "Gestion des pré-factures",
      createPreInvoiceD: "Créer une pré-facture",
      item: "Article",
      total: "Total",
      consumedCount: "Quantité consommée",
      editPreInvoiceD: "Modifier la pré-facture",
      addPreInvoiceD: "Ajouter une pré-facture",
      invoiceManagement: "Gestion des factures",
      createInvoice: "Créer une facture",
      editInvoice: "Modifier la facture",
      addInvoice: "Ajouter une facture",
      DateIssued: "Date d'émission",
      InvoiceDetails: "Détails de la facture",
      Discount: "Remise",
      NetAmount: "Montant net",
      AddItem: "Ajouter un article",
      InstallmentCount: "Nombre de versements",
      TotalAmount: "Montant total",
      Unpaid: "Non payé",
      Paid: "Payé",
      Overdue: "En retard",
      SelectItem: "Sélectionner un article",
      addLevel: "Ajouter un niveau",
      Regular: "Régulier",
      Support: "Support",
      Training: "Formation",
      employeeManagement: "Gestion des employés",
      createEmployee: "Créer un employé",
      editEmployee: "Modifier un employé",
      addEmployee: "Ajouter un employé",
      position: "Poste",
      salary: "Salaire",
      benefits: "Avantages",
      contractDocument: "Document du contrat",
      employeeName: "Nom de l'employé",
      positionTitle: "Intitulé du poste",
      serviceManagement: "Gestion des services",
      createService: "Créer un service",
      editService: "Modifier un service",
      addService: "Ajouter un service",
      ServiceCode: "Code du service",
      ServiceName: "Nom du service",
      DefaultUnitPrice: "Prix unitaire par défaut",
      Available: "Disponible",
      Unavailable: "Indisponible",
      DefaultUnitCount: "Nombre d'unités par défaut",
      productManagement: "Gestion des produits",
      createProduct: "Créer un produit",
      editProduct: "Modifier le produit",
      addProduct: "Ajouter un produit",
      ProductName: "Nom du produit",
      enrollmentManagement: "Gestion des inscriptions",
      createEnrollment: "Créer une inscription",
      editEnrollment: "Modifier l'inscription",
      addEnrollment: "Ajouter une inscription",
      Enrolled: "Inscrit",
      Dropped: "Abandonné",
      EnrollmentDate: "Date d'inscription",
      scheduleManagement: "Gestion des horaires",
      createSchedule: "Créer un horaire",
      editSchedule: "Modifier l'horaire",
      addSchedule: "Ajouter un horaire",
      HourVolume: "Volume horaire",
      DayOfWeek: "Jour de la semaine",
      StartTime: "Heure de début",
      EndTime: "Heure de fin",
      Location: "Emplacement",
      attendanceManagement: "Gestion des présences",
      createAttendance: "Créer un enregistrement de présence",
      editAttendance: "Modifier un enregistrement de présence",
      addAttendance: "Ajouter un enregistrement de présence",
      Schedule: "Horaire",
      Date: "Date",
      InReview: "En cours de révision",
      Reviewed: "Révisé",
      Approved: "Approuvé",
      Reported: "Signalé",
      AttendanceStatus: "Statut de présence",
      Present: "Présent",
      Absent: "Absent",
      Late: "En retard",
      AddStudent: "Ajouter un élève",
      studentAttendance: "Présence des élèves",
      teacherAttendance: "Présence des enseignants",
      ticketManagement: "Gestion des tickets",
      createTicket: "Créer un ticket",
      addTicket: "Ajouter un ticket",
      editTicket: "Modifier un ticket",
      title2 :"Titre",
      OPEN: "Ouvert",
      CLOSED: "Fermé",
      Priority: "Priorité",
      low: "Bas",
      medium: "Moyenne",
      high: "Élevée",
      Comments: "Commentaires",
      AddComment: "Ajouter un commentaire",
      Attachments: "Pièces jointes",
      AddAttachment: "Ajouter une pièce jointe",
      assignee: "Assigné",
      abilitiesManagement: "Gestion des permissions",
      createAbility: "Créer une persmission",
      resetAbilities: "Réinitialiser les persmissions",
      deleteAbilities: "Supprimer les permissions",
      updateAbilities: "Mettre à jour les permissions",
      cloneAbilities: "Cloner les permissions",
      roleName: "Nom du rôle",
      origin: "Origine",
      abilitiesCount: "Nombre de permissions",
      NewRoleName: "Nouveau nom de rôle",
      Manage: "Gérer",
      Create: "Créer",
      Read: "Lire",
      Update: "Mettre à jour",
      Delete: "Supprimer",
      Documents: "Documents",
      notificationSettings: "Paramètres des notifications",
      enabled: "Activé",
      disabled: "Désactivé",
      emailNotifications: "Notifications par e-mail",
      pushNotifications: "Notifications push",
      appearanceSettings: "Paramètres d'apparence",
      languageSettings: "Paramètres de langue",
      language: "Langue",
      french: "Français",
      english: "Anglais",
      arabic: "Arabe",
      additionalSettings: "Paramètres supplémentaires",
      otherSettings: "Autres paramètres",
      AccountStatus: "Statut du compte",
      saveChanges: "Enregistrer les modifications",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      updatePassword: "Mettre à jour le mot de passe",
      Title: "Titre",
      AddManager: "Ajouter un responsable",
      newRoleName: "Nom du nouveau rôle",
      reloadData: "Recharger les données",
      SearchStudents: "Rechercher des élèves",
      writing_training: "Formation écriture",
      english_training: "Formation anglais",
      quran_training: "Formation Quran",
      teacher: "Enseignant",
      all: "Tous",
      read: "Lu",
      not_read: "Non lu",
      filter_by_status: "Filtrer par statut",
      grades: "Notes",
      assignment: "Devoir",
      exam: "Examen",
      exercise_count: "Nombre d'exercices",
      assignment_points: "Notes du devoir dans la matière",
      exercise_point: "Note de l'exercice",
      activity_evaluation_rate: "Taux d'évaluation des activités",
      grades2: "Notes",
      exercise: "Exercice",
      integration_status: "Exercice final",
      points: "Notes",
      product: "Produit",
      payment_received: "Reçu de paiement",  
      period: "Période",
      payment: "Versement",
      remaining_balance: "Reste à payer",
      total_amount: "Montant Total",
      total_payment_received: "Total reçu de paiement",
      filter_payment_receipts: "Filtrer les reçus de paiements",
      student_in_period: "élève dans une période",
      user_in_period: "utilisateur dans une période",
      NewDirectorDetails: "Détails du nouveau directeur",
      print: "Impression",
      positionManagement: "Gestion des postes",
      filledPositions: "Postes pourvus",
      authorizedPositions: "Postes autorisés",
      createPosition: "Créer un poste",
      editPosition: "Modifier un poste",
      addPosition: "Ajouter un poste",
      by: "par",
      filterInvoices: "Filtrer les factures",
      message_sent_success: "Le message a été envoyé avec succès",
      message_sent_error: "Erreur lors de l'envoi du message",
      select_organization: "Choisir une organisation",
      select_institution: "Choisir une institution",
      select_class: "Choisir une classe",
      listIsEmpty: "La liste est vide",
      myChildren: "Mes enfants",
      Remedial: "Rattrapage",
      comments: "Commentaires",
      attachments: "Pièces jointes",
      Browse: "Parcourir",
      Filename: "Nom de fichier",
      Comment: "Commentaire",
      addRole: "Ajouter un rôle",
      Parameters: "Paramètres",
      roleName: "Nom du rôle",
      Role: "Rôle",
      editRole: "Modifier un rôle",
      userRoles: "Rôles de l'utilisateur",
      statistic: "Statistiques",
      operationSuccessful: "Opération réussie !",
      confirmDelete: "Confirmer la suppression",
      areYouSureYouWantToDelete: "Êtes-vous sûr de vouloir supprimer ?",
      delete: "Supprimer",
      algerianDemocraticRepublic: "République Algérienne Démocratique et Populaire",
      ministryOfEducation: "Ministère de l'Éducation",
      educationDirectorateTlemcen: "Direction de l'Éducation - Tlemcen",
      schoolYear: "Année Scolaire",
      tissouraMansoura: "Ecole Privée Tissoura-Mansourah",
      number: "Numéro : ",
      schoolCertificate: "Certificat Scolarité",
      certificateDirectorStatement: "Le directeur de l'établissement certifie que l'élève : ",
      certificateBirthInfo: "Date et lieu de naissance : ",
      certificateStudyStatus: "Continue ses études",
      registrationNumber: "Numéro d'enregistrement :",
      issuedInMansoura: "Tlemcen le :",
      previousNameAndSurnameWriting: "Écriture précédente du nom et du prénom",
      schoolDirector: "Directeur de l'école privée Tissoura",
      tissouraPrivateSchool: "Tissoura Privée",
      educational_group: "Classe",
      issued_by: "Publié par",
      mansoura: "Mansourah",
      school_id_number: "Numéro d'identification scolaire",
      exit_date: "Date de sortie",
      to_this_day: "Jusqu'à ce jour",
      newPassword: "Nouveau mot de passe",
      resetPassword: "Réinitialiser le mot de passe",
      student_exit_log: "Registre de sortie",
      logout_record: "Registre de sortie",
      teacher_schedule: "Emploi du temps des enseignants",
      class_schedule: "Emploi du temps de la classe",
      print_teacher_schedule: "Imprimer l'emploi du temps de l'enseignant",
      Monday: "Lundi",
      Tuesday: "Mardi",
      Wednesday: "Mercredi",
      Thursday: "Jeudi",
      Friday: "Vendredi",
      Saturday: "Samedi",
      Sunday: "Dimanche",
      teacher_schedule : "Emploi du temps de l'enseignant", 
      placeOfBirth: "Lieu de naissance",
      location: "à",
      number_of_minutes: "Nombre de minutes",
      due_date: "Date d'échéance",
      guide_title: "Guide du module 'Élèves'",
      add_student: "Ajouter un nouvel élève",
      modify_student: "Modifier les informations d'un élève",
      step1: "Connectez-vous à l'application.",
      step2: "Accédez au module 'Élèves' dans le menu principal.",
      step3: "Cliquez sur le bouton 'Ajouter un élève'.",
      step4: "Remplissez les informations demandées (utilisateur, niveau, établissement, etc.).",
      step5: "Validez pour enregistrer l'élève.",
      edit_student_info: "Pour modifier les informations de l'élève, cliquez sur",
      save_student_info: "Cliquez sur 'Enregistrer' pour sauvegarder les informations de l'élève",
      user_not_found: "Si vous ne trouvez pas l'utilisateur dans la liste, cliquez sur 'Ajouter un nouvel élève'",
      fill_save_info: "Remplissez les informations requises, puis cliquez sur 'Enregistrer'",
      generate_school_certificate: "Pour générer une attestation scolaire, cliquez sur",
      classes_guide: "Guide du module 'Classes'",
      add_new_class: "Ajouter une nouvelle classe",
      navigate_to_classes: "Accédez au module 'Scolarité' depuis le menu principal.",
      click_add_class: "Cliquez sur le bouton Ajouter une classe",
      fill_required_info_c: "Remplissez les informations requises (Nom de la classe, Niveau, Année scolaire, etc.)",
      click_save_class: "Cliquez sur 'Enregistrer' pour ajouter la classe",
      click_save_edit_class: "Cliquez sur 'Enregistrer' pour enregistrer les modifications.",
      click_save_class_info: "Cliquez sur 'Enregistrer' pour sauvegarder les informations de la classe",
      edit_class_info: "Modifier les informations de la classe",
      click_edit_class_info: "Pour modifier les informations de la classe, cliquez sur",
      registration_procedure: "Protocole d'inscription",
      prepare_data: "Préparation des données",
      prepare_student: "Si l'élève n'est pas encore créé, créez-le en suivant le 'Guide Élèves'.",
      prepare_class: "Si la classe n'existe pas, créez-la en suivant le 'Guide Classes'.",
      access_registration: "Accéder au module d'inscription",
      select_registration_module: "Depuis le menu principal, sélectionnez le module 'Inscriptions'.",
      create_registration: "Créer une nouvelle inscription",
      click_create_registration: "Cliquez sur le bouton 'Créer une inscription'.",
      fill_registration_info: "Remplir les informations requises",
      registration_details: "Sélectionnez et renseignez les informations suivantes : Élève, Classe, Date d'inscription, Institution, Statut.",
      save_registration: "Enregistrer l'inscription",
      click_save_registration: "Cliquez sur le bouton 'Enregistrer' pour valider l'inscription.",
      see_guide: "Voir le guide",
      activities_unit_guide: "Guide du module 'Activités'",
      add_new_activity: "Ajouter une nouvelle activité",
      go_to_students_unit: "Accédez au module 'Élèves' depuis le menu principal",
      fill_required_information: "Remplissez les informations requises (matière, section, description, etc.)",
      go_to_activities_unit: "Accédez au module 'Activités' depuis le menu secondaire",
      click_add_button: "Cliquez sur le bouton Ajouter",
      click_save_to_add_activity: "Cliquez sur 'Sauvegarder' pour ajouter l'activité",
      module_description: "Ce module permet de suivre les activités assignées aux élèves, facilitant l'ajout, la gestion et le suivi de chaque activité, tout en permettant une navigation fluide entre les unités 'Activités' et 'Élèves'.",
      edit_activity_information: "Modifier les informations de l'activité",
      to_edit_activity_information_click_on: "Pour modifier les informations de l'activité, cliquez sur",
      click_save_to_save_activity: "Cliquez sur 'Enregistrer' pour enregistrer l'activité",
      to_add_follow_up_to_activity_click_on: "Pour ajouter un suivi à l'activité, cliquez sur",
      to_view_activity_follow_ups_click_on: "Pour voir les suivis de l'activité, cliquez sur",
      add_follow_up_to_activity: "Ajouter un suivi à l'activité",
      to_view_follow_up_details_click_on: "Pour voir les détails du suivi, cliquez sur",
      to_edit_follow_up_click_on: "Pour modifier le suivi, cliquez sur",
      to_delete_follow_up_click_on: "Pour supprimer le suivi, cliquez sur",
      to_view_activity_follow_ups_for_section_in_period_click_on: "Pour voir les suivis d'activités pour une section sur une période spécifique, cliquez sur le bouton 'Afficher le suivi'",
      to_view_students_work_statistics_click_on: "Pour voir les statistiques de travail des élèves, cliquez sur 'Statistiques des élèves'",
      to_view_specific_student_report_click_on: "Pour voir le rapport d'un élève spécifique, cliquez sur 'Rapport de l'élève'",
      follow_up_protocol: "Protocole de Suivi des Activités",
      create_activity: "Création d'une Activité",
      create_follow_up: "Création d'un ou plusieurs suivis pour l'activité",
      consult_follow_up: "Consultation des suivis dans une période spécifique",
      support_lessons_guide: "Guide du module 'cours de soutien'",
      navigate_support_lessons: "Accéder à l'unité 'Cours de soutien' depuis le menu secondaire",
      save_support_lesson: "Cliquez sur 'Enregistrer' pour sauvegarder le cours de soutien",
      add_support_lesson: "Ajout d'un cours de soutien",
      modify_support_lesson: "Modifier le cours de soutien",
      modify_support_lesson_info: "Pour modifier les informations du cours de soutien, cliquez sur",
      click_save_to_save_support_lesson: "Cliquez sur Enregistrer pour sauvegarder le cours de soutien",
      add_follow_up_to_support_lesson: "Pour ajouter un suivi au cours de soutien, cliquez sur",
      view_follow_up_for_support_lesson: "Pour voir le suivi du cours de soutien, cliquez sur",
      modify_and_save_follow_up: "Vous pouvez modifier le suivi, puis cliquer sur Enregistrer",
      support_lesson_follow_up_module_description: "This module allows tracking of support lessons for students.",
      requests: "Demandes",
      createRequest: "Créer une demande",
      filterRequest: "Filtrer les demandes",
      Pending: "En attente",
      Purchased: "Acheté",
      manage_requests: "Gestion des demandes",
      editRequest: "Modifier la demande",
      requestDetails: "Détails de la demande",
      notebookTracking: "Suivi des cahiers",
      addTracking: "Ajouter un suivi",
      trackingAddedSuccess: "Le suivi a été ajouté avec succès",
      trackingUpdatedSuccess: "Le suivi a été modifié avec succès",
      editTracking: "Modifier le suivi",
      lessonCompleted: "Le cours a été complété",
      lessonNotCompleted: "Le cours n'a pas été complété",
      handwritingImprovement: "Amélioration de l'écriture",
      inProgress: "En cours",
      consult_follow_up_SC: "Pour voir les suivis des cours de soutien pour une section sur une période donnée, cliquez sur le bouton 'Consulter l'évaluation'.",
      behavior_module_guide: "Guide du module de 'comportement'",
      behavior_module_description: "Ce module permet de suivre le comportement des élèves",
      navigate_behavior_module: "Accédez au module de 'comportement' depuis le menu latéral",
      click_evaluate_students: "Cliquez sur le bouton 'Évaluer les élèves'",
      fill_required_info: "Remplissez les informations requises (matière, classe, type d'évaluation, etc.)",
      click_save: "Cliquez sur 'Enregistrer'",
      evaluate_each_student: "Évaluez chaque élève selon son niveau (A, B, C)",
      view_evaluation: "Pour afficher l'évaluation par matière et classe sur une période donnée, cliquez sur 'Consulter l'évaluation'",
      notebook_tracking_guide: "Guide de 'suivi des cahiers'",
      notebook_tracking_description: "Ce module permet le suivi des cahiers des élèves",
      navigate_notebook_tracking: "Accédez au module de 'suivi des cahiers' depuis le menu latéral",
      fill_required_info_notebook: "Remplissez les informations requises (matière, classe, institution, etc.)",
      click_on: "Cliquez sur",
      edit_tracking_info: "Pour modifier les informations de suivi, cliquez sur",
      view_tracking_details: "Pour voir les détails du suivi, cliquez sur",
      view_notebook_tracking: "Pour voir le suivi des cahiers d'une classe sur une période donnée, cliquez sur le bouton 'Afficher le suivi' (le filtrage par matière est possible)",
      meetings_module_guide: "Guide du module 'Réunions'",
      meetings_module_description: "Ce module permet la gestion des réunions entre les enseignants et les parents d'élèves.",
      navigate_meetings_module: "Accédez au module 'Réunions' depuis le menu latéral.",
      add_meeting: "Ajouter une réunion",
      click_meeting_form: "Cliquez sur le formulaire de réunion",
      fill_meeting_info: "Remplissez les informations requises : enseignant, parent, date, etc.",
      edit_meeting_info: "Pour modifier les détails de la réunion, cliquez sur",
      view_meeting_details: "Pour voir les détails de la réunion, cliquez sur",
      support_course_tracking_protocol: "Protocole de suivi des cours de soutien",
      add_support_course: "Ajouter un cours de soutien",
      add_support_course_tracking: "Ajouter un suivi pour le cours de soutien",
      view_support_course_tracking: "Afficher les suivis des cours de soutien sur une période donnée (filtrage par matière disponible)",
      add_notebook_tracking: "Ajouter un suivi des cahiers",
      add_tracking_details: "Ajouter des détails de suivi après avoir vérifié les cahiers des élèves",
      view_notebook_tracking_p: "Afficher le suivi des cahiers pour une période spécifique (peut être affiché par matière)",
      notebook_tracking_protocol: "Protocole de suivi des cahiers",
      payroll: "Paie",
      PayPeriod: "Période de paie",
      GrossPay: "Salaire brut",
      NetPay: "Salaire net",
      PaymentMethod: "Mode de paiement",
      Employee: "Employé",
      payroll_management: "Gestion de la paie",
      create_payroll: "Créer la paie",
      add_payroll: "Ajouter une paie",
      edit_payroll: "Modifier la paie",
      MONTHLY: "Mensuel",
      PER_SESSION: "Par séances",
      Cash: "Espèces",
      PERCENTAGE: "Pourcentage",
      module_guide_subjects: "Guide du module 'Matières'",
      add_new_subject: "Ajouter une nouvelle matière",
      navigate_to_subjects_module: "Accédez au module 'Matières' depuis le menu secondaire",
      click_add_subject: "Cliquez sur le bouton Ajouter une matière",
      click_save_to_add_subject: "Cliquez sur 'Enregistrer' pour ajouter la matière",
      fill_required_information_s: "Remplissez les informations requises (nom de la matière, description, niveau, etc.)",
      edit_subject_information: "Modifier les informations de la matière",
      click_to_edit_subject_information: "Pour modifier les informations de la matière, cliquez sur",
      click_save_to_save_subject: "Cliquez sur 'Enregistrer' pour sauvegarder la matière",
      reports: "Rapports",
      create_report: "Créer un rapport",
      manage_reports: "Gérer les rapports",
      title: "Titre",
      description: "Description",
      date_of_report: "Date du rapport",
      file_url: "URL du fichier",
      add_report: "Ajouter un rapport",
      edit_report: "Modifier un rapport",
      created_by: "Créé par",
      canceled: "Annulé",
      print_payment_notice: "Impression avis",
      payment_notice_on: "Avis de paiement le :",
      education_levels: "Préscolaire - Primaire - Moyen",
      print_student_list: "Imprimer la liste des élèves",
      number_of_sessions: "Nombre de séances",
      minutes: "Minutes",
      calls: "Appels",
      call_management: "Gestion des appels",
      contact_list: "Liste des contacts",
      course_schedule: "Calendrier des cours",
      print_course_schedule: "Imprimer le calendrier des cours",
      day : "Jour",
      timeS: "Heure",
      phone_number: "Numéro de téléphone",
      remaining: "Reste",
      levels_module_guide: "Guide du module 'Niveaux'",
      add_new_level: "Ajouter un nouveau niveau",
      navigate_to_levels_module: "Accédez au module 'Niveaux' depuis le menu secondaire.",
      click_add_level: "Cliquez sur le bouton Ajouter un niveau.",
      fill_required_level_information: "Remplissez les informations requises (nom du niveau, description, etc.).",
      click_save_to_add_level: "Cliquez sur 'Enregistrer' pour ajouter le niveau.",
      edit_level_information: "Modifier les informations du niveau",
      click_to_edit_level_information: "Pour modifier les informations du niveau, cliquez sur",
      click_save_to_save_level: "Cliquez sur 'Enregistrer' pour sauvegarder le niveau",
      create_subjects_if_not_available: "Si les matières ne sont pas disponibles, créez-les via le guide 'Matières'.",
      enroll_students_in_classes: "Inscrire les élèves dans les classes",
      add_ability: "Ajouter une permission",
      edit_ability: "Modifier la permission",
      action: "Action",
      subject: "Sujet",
      conditions_json: "Conditions (JSON)",
      updating: "Mise à jour...",
      update_abilities: "Mettre à jour les  permissions",
      add_role: "Ajouter un rôle",
      accounting: "Comptabilité",
      accounts: "Comptes",
      transaction_journal: "Journal des transactions",
      owner_name: "Nom du propriétaire",
      balance: "Solde",
      add_account: "Ajouter un compte",
      edit_account: "Modifier un compte",
      accounts_management: "Gestion des comptes",
      owner_type: "Type de propriétaire du compte",
      remaining_amount: "Reste",
      to_be_paid: "À payer",
      pay_invoices: "Payer les factures",
      refund_receipt: "Reçu de remboursement",
      refund: "Remboursement",
      observation: "Observation",
      signature: "Signature",
      and: "et",
      payment_statement: "Relevé de compte",
      refund_date: "Date Remboursement",
      allClasses: "Toutes les classes",
      sessions : "Séan",
      week: "semaine",
      student_not_registered: "L'élève n'est pas inscrit",
      hello: "Bonjour",
      json_export_error: "Une erreur s'est produite lors du téléchargement des données JSON.",
      add_industry: "Ajouter une industrie",
      edit_industry: "Modifier l'industrie",
      upload_json_file: "Importer un fichier JSON",
      selected_file: "Fichier sélectionné :",
      json_file: "Fichier JSON",
      choose_file: "Choisir un fichier",
      please_select_a_file: "Veuillez sélectionner un fichier",
      invalid_json_file: "Fichier JSON invalide !",
      Personal: "Personnel",
      Editing: "Édition",
      validation_failed: "Échec de la validation : Veuillez vous assurer que tous les champs enfants sont remplis.",
      approved_by_ministry: "Agréée par le Ministère de l'Éducation",
      net: "Net",
      rc : "RC",
      nif : "NIF",
      emailInvoice : "EMAIL",
      invoice_journal: "Journal des Factures",
      totalInvoice: "Total",
      agent_signature: "Signature de l'Agent",
      institution_stamp: "Cachet de l'établissement",
      tel : "TEL",
      amount_in_words: "La somme en lettres",
      dzd: "Dinars Algériens",
      fb : "FB",
      client: "Client",
      payment_journal: "Journal des paiements",
      until: "jusqu'à",
      subTitle: "Sous-titre",
      Confirmed: "Confirmé",
      Billed: "Facturé",
      add_preinvoices: "Ajouter des pré-factures",
      schoolLevels: "Niveaux scolaires",
      PRIMARY: "École primaire",
      MIDDLE: "Collège",
      SECONDARY: "Lycée",
      OTHER: "Autre",
      category: "Catégorie",
      TUITION: "Frais de scolarité",
      TRANSPORT: "Transport",
      CANTEEN: "Cantine",
      ACTIVITY: "Activité",
      print_pre_invoices: "Imprimer les pré-factures",
      pre_invoices: "Pré-factures",
      defaultUnit: "Unité par défaut",
      MONTH: "Mois",
      WEEK: "Semaine",
      SEANCE: "Séance",
      UNITLESS: "Sans unité",
      all_services: "Tous les services",
      pre_invoice: "Pré-facture",
      transaction_journal: "Journal des transactions",
      number_of_registrations: "Nombre d'inscriptions",
      ministry_platform: "Plateforme du Ministère",
      black_list: "Liste noire",
      code_class: "Code de la classe",
      level_code: "Code du niveau",
      class_list: "Liste des classes",
      totalS: "Total",
      verify_payment: "Vérifier le paiement",
      Exited: "Transfert",
      archive: "Archive",
      maxStudents: "Nombre maximum d'élèves",
      minStudents: "Nombre minimum d'élèves",
      jobs: "Emplois",
      unregistered_ministry: "Élèves non inscrits sur la plateforme du ministère",
      Archived: "Archivé",
      Deleted: "Supprimé",
      archiveStatus: "Statut d'archivage",
      students_archive: "Archive des élèves",
      classes_archive: "Archive des classes",
      registrations_archive: "Archive des inscriptions",
      jobsManagement: "Gestion des postes",
      candidates: "Candidats",
      teachers_archive: "Archive des enseignants",
      SPORT: "Sport",
      discountRate: "Taux de remise",
      with_preinvoice_creation: "Avec création d'une préfacture",
      without_preinvoice_creation: "Sans création d'une préfacture",
      groups: "Groupes",
      group:"Group",
      groups_management: "Gestion des groupes",
      add_group: "Ajouter un groupe",
      edit_group: "Modifier le groupe",
      group: "Groupe",
      group_name: "Nom du groupe",
      code_group: "Code du groupe",
      referred_by: "Recommandé par",
      applicants: "Candidats",
      applicantsManagement: "Gestion des candidats",
      applicantName: "Nom du candidat",
      createApplicant: "Ajouter un candidat",
      editApplicant: "Modifier le candidat",
      addNewApplicant: "Ajouter un nouveau candidat",
      preInvoice: "Pré-facture",
      pendingClass: "En attente",
      ANNUAL: "Frais d'inscription",
      applications: "Candidatures",
      applicationManagement: "Gestion des candidatures",
      createApplication: "Créer une candidature",
      ApplicationDate: "Date de candidature",
      job: "Poste",
      editApplication: "Modifier la candidature",
      applicant: "Candidat",
      editInterview: "Modifier l'entretien",
      createInterview: "Créer un entretien",
      AddTeacher: "Ajouter un enseignant",
      totalAbsent: "Total d'absences",
      totalLate: "Total de retards",
      totalPresent: "Total de présences",
      dailyAttendanceReport: "Rapport journalier de présence",
      justification: "Justification",
      MedicalCertificate: "Certificat médical",
      None: "Aucune",
      reason: "Raison",
      PreEnrolled: "Préinscrit",
      editRefund: "Modifier le remboursement",
      mainList: "Liste principale",
      followUpList: "Liste de suivi",
      creditStatus: "État de crédit",
      subscribers: "Abonnés",
      subscribersManagement: "Gestion des abonnés",
      annualFeeManagement: "Gestion des frais d'inscription",
      PartiallyPaid: "Partiellement payé",
      individualBilling: "Facturation individuelle",
      groupBilling: "Facturation groupée",
      interviewer: "Interviewer",
      humanResources: "Ressources humaines",
      registrationLog: "Journal des inscriptions",
      subscribersLog: "Journal des abonnés",
      PHASE1: "Phase 1",
      PHASE2: "Phase 2",
      PHASE3: "Phase 3",
      PENDING: "En attente",
      ACCEPTED: "Accepté",
      REJECTED: "Refusé",
      UNDER_REVIEW: "En cours d'examen",
      phase: "Phase",
      interviewResult: "Résultat de l'entretien",
      interviewNotes: "Notes de l'entretien",
      nis: "NIS"
    },
  },
  ar: {
      translation: {
        login: 'تسجيل الدخول',
        register: 'التسجيل',
        forgotPassword: 'هل نسيت كلمة المرور؟',
        resetPassword: 'إعادة تعيين كلمة المرور',
        emailPlaceholder: 'أدخل بريدك الإلكتروني',
        usernamePlaceholder: 'أدخل اسم المستخدم',
        passwordPlaceholder: 'أدخل كلمة المرور',
        confirmPasswordPlaceholder: 'تأكيد كلمة المرور',
        rememberPassword: 'هل تتذكر كلمة المرور الخاصة بك؟',
        haveAccount: 'هل لديك حساب بالفعل؟ قم بتسجيل الدخول هنا',
        noAccount: 'ليس لديك حساب؟ سجل هنا',
        tissouraLogoAlt: 'تيسورة',
        dashboard: 'القيادة',
        profile: 'الملف الشخصي',
        statistics: 'الإحصائيات',
        messages: 'رسائل',
        notifications: 'إشعارات',
        settings: 'الإعدادات',
        user: 'مستخدم',
        users: 'المستخدمين',
        status: 'الحالة',
        actions: 'الإجراءات',
        details: 'التفاصيل',
        edit: 'تعديل',
        delete: 'حذف',
        addUser: 'إضافة مستخدم',
        userDetails: 'تفاصيل المستخدم',
        id: 'معرف',
        email: 'البريد الإلكتروني',
        active: 'نشط',
        inactive: 'غير نشط',
        save: 'حفظ',
        close: 'إغلاق',
        darkMode: "الوضع الداكن",
        changeLanguage: "تغيير اللغة",
        name: "الاسم",
        phone: "الهاتف",
        address: "العنوان",
        userPages: 'صفحات المستخدم',
        search: 'بحث...',
        personalData: 'البيانات الشخصية',
        role: 'الدور',
        totalUsers:" إجمالي المستخدمين",
        activeUsers:" المستخدمون النشطون",
        pendingTasks:" المهام المعلقة",
        completedTasks:" المهام المكتملة",
        totalRevenue:" إجمالي الإيرادات",
        newOrders:" طلبات جديدة",
        conversionRate:" معدل التحويل",
        siteVisits:" زيارات الموقع",
        userGrowth:" نمو المستخدمين",
        newUserRegistered:" تم تسجيل مستخدم جديد",
        serverDowntime:" وقت تعطل الخادم",
        newOrderReceived:" تم استلام طلب جديد",
        userFeedbackReceived:" تم استلام ردود فعل المستخدم",
        totalEmployees: "إجمالي الموظفين",
        totalTeachers: "إجمالي المعلمين",
        totalStudents: "إجمالي التلاميذ",
        students: "التلاميذ",
        Employee: "موظف",
        documents: "مستندات",
        logout: "الخروج",
        welcomeTitle: "مرحبًا بكم في تيسورا",
        welcomeDescription1: "في تيسورا، نقدم تعليمًا عالي الجودة لتعزيز نمو وتطور طلابنا. انضم إلينا لمنح أطفالك أفضل بداية في الحياة.",
        welcomeDescription2: "تشمل مدرستنا مؤسستين: تيسورا الابتدائية وتيسورا المتوسطة، كل منهما مكرسة لتقديم تعليم استثنائي في كل مرحلة من مراحل تعلم طفلك.",
        servicesTitle: "خدماتنا",
        servicesDescription: "نقدم مجموعة من الخدمات التعليمية المصممة لتلبية احتياجات طلابنا، بما في ذلك خطط التعلم الشخصية، والأنشطة اللامنهجية، والمرافق الحديثة.",
        contactTitle: "اتصل بنا",
        contactDescription: "إذا كانت لديك أي أسئلة أو ترغب في معرفة المزيد عن برامجنا، لا تتردد في الاتصال بنا.",
        joinUsButton: "انضم إلينا الآن",
        about: "حول",
        services: "الخدمات",
        contact: "اتصل",
        schoolDescription: "مدرسة معتمدة من وزارة التربية الوطنية (تحضيري - ابتدائي - متوسط)",
        home: "الرئيسية",
        test: "اختبار",
        courses: "مستويات",
        about_us: "من نحن",
        contact_us: "سجل الآن",
        sign_up: "التسجيل",
        sign_in: "تسجيل الدخول",
        titleTS: "مرحبًا بك في مدرسة تيسورة الخاصة",
        welcome_message: "مرحبًا بكم في مدرستنا الخاصة تيسورا، المكرسة لتقديم تعليم عالي الجودة للطلاب في ثلاثة مستويات [روضة، ابتدائية، متوسطة]، مع التزام بالتميز الأكاديمي، وبيئة حاضنة، وبرامج تعليمية محفزة. تهدف مدرستنا إلى رعاية إمكانيات كل طالب في كل مرحلة من مراحل تطورهم.",
        explore_message: "انضموا إلينا في رحلة تعليمية ثرية، حيث التعلم، والإبداع، والنمو الشخصي في قلب مهمتنا.",
        preschool_level: "مستوى روضة الأطفال",
        preschool_description: "روضة الأطفال لدينا مكان مرح حيث يكتشف الصغار ويلعبون وينمون. يوجههم المعلمون المتفانون خلال أنشطة ممتعة تعزز التطور الاجتماعي والعاطفي والفكري. هنا، كل يوم هو مغامرة صغيرة في التعلم لإعداد الأطفال لمسيرتهم التعليمية.",
        primary_level: "المستوى الابتدائي",
        primary_description: "في المستوى الابتدائي في مدرستنا تيسورا، كل صف دراسي هو مركز تعليمي ديناميكي. يخلق معلمونا المتفانون بيئة يتم فيها إثارة الفضول، وتكوين الصداقات، وإحياء المعرفة. من خلال مشاريع محفزة وأنشطة تفاعلية، نشجع طلابنا على تطوير المهارات الأساسية التي يحتاجونها. معًا، نشكل مسارًا تعليميًا مثيرًا يُعد طلابنا لمستقبل مشرق.",
        middle_level: "المستوى المتوسط",
        middle_description: "في المستوى المتوسط، يُدعى كل طالب للمشاركة في رحلة تعليمية ديناميكية. تصبح الفصول الدراسية مساحات للاكتشاف، حيث يتم تشجيع التفكير النقدي، وتُواجه التحديات الأكاديمية بالعزم. يوجه معلمونا المتفانون طلابنا نحو الاستقلالية الفكرية مع تنمية بيئة يتجاوز فيها التعلم الكتب الدراسية.",
        offers_title: "تدريب، تعلم اللغات، الألعاب",
        soroban_title: "سوروبان",
        soroban_description: "سوروبان: تطوير المهارات الإدراكية من خلال الحساب الذهني باستخدام السوروبان.",
        languages_title: "تعلم اللغات",
        languages_description: "تعلم اللغات: إثراء مهاراتك اللغوية من خلال دورات اللغة لجميع الأعمار.",
        games_title: "الألعاب التعليمية",
        games_description: "الألعاب التعليمية: استمتع بالتعلم من خلال الألعاب التعليمية التفاعلية والممتعة.",
        programming: "البرمجة",
        programming_intro: "نقوم بتعليم الأطفال البرمجة باستخدام أدوات حديثة مثل Micro:bit لتطوير إبداعهم ومهاراتهم الرقمية",
        quality_title: "التعليم الجيد",
        quality_description: "التزامنا بتوفير تعليم عالي الجودة للطلاب في تيسورا يعتمد على نهج شامل. نُعزز تطوير كل طالب من خلال برامج محفزة، واهتمام شخصي، وبيئة حاضنة.",
        administration_title: "الإدارة",
        administration_description1: "نلتزم بخلق بيئة مشجعة للتعلم والنمو.",
        administration_description2: " لا تترددوا في الاتصال بنا لأي أسئلة أو معلومات إضافية. تضمن فريقنا الإداري التشغيل السلس لمؤسستنا ورفاهية كل طالب. نلتزم بخلق بيئة مشجعة للتعلم والنمو.",
        administration_description3: "لا تترددوا في الاتصال بنا لأي أسئلة أو معلومات إضافية.",
        your_email: "بريدك الإلكتروني",
        your_message: "رسالتك",
        send_message: "إرسال الرسالة",
        all_rights_reserved: "كل الحقوق محفوظة.",
        ourSchool: "مدرستنا",
        ourSchoolDescription: "نفتخر بتقاليدنا التعليمية وإنجازاتنا الشهيرة.",
        whyChooseUs: "لماذا تختارنا؟",
        whyChooseUsDescription: "مدرستنا معروفة بتميزها في تعليم الشباب.",
        activities: "الأنشطة",
        activitiesDescription: "نحن نقدم مجموعة واسعة من الأنشطة لطلابنا.",
        certifications: "الشهادات",
        certificationsDescription: "نحن فخورون بسمعتنا في مجال العلوم، مما يعكس التزامنا المستمر بتقديم تعليم عالي الجودة.",
        reputation: "السمعة",
        reputationDescription: "لدينا سمعة جيدة للتعليم والتعلم الودي.",
        library: "المكتبة",
        libraryDescription: "لدينا أحدث مكتبة لتلبية احتياجات الطلاب المرجعية.",
        quran_learning_title: "تعلم القرآن",
        quran_learning_description: "امنح نفسك الفرصة لتعلم القرآن من خلال برامجنا المخصصة لجميع المستويات.",
        writing_improvement_title: "تحسين الكتابة",
        writing_improvement_description: "قم بتحسين مهاراتك في الكتابة من خلال الدورات المتخصصة والتمارين العملية.",
        learnMore: "تعلم أكثر",
        school_title: "مدرسة خاصة معتمدة من الدولة [الروضة - الابتدائي - المتوسط]",
        school_in:"[الروضة - الابتدائي - المتوسط]",
        photo_gallery: "معرض الصور",
        video_gallery: "معرض الفيديوهات",
        behavior : "السلوك",
        add :  "أضف",
        class: "القسم",
        Subject : "المادة " ,
        activityType: "نوع النشاط",
        assignedDate: "تاريخ التعيين",
        dueDate: "تاريخ الانتهاء",
        description: "الوصف",
        activityList: "قائمة الأنشطة",
        addActivity: "إضافة نشاط",
        Homework: "واجب",
        Extracurricular: "نشاط خارج المنهج",
        editActivity: "تعديل النشاط",
        ActivityFollowUp: "متابعة النشاط",
        StudentList:  " قائمة التلاميذ ",
        fraudulent: "احتيالي",
        completed: "مكتمل",
        incompleted: "غير مكتمل",
        pending: "قيد الانتظار ",
        absent : "غائب ",
        dataRetrieval: "استرداد البيانات ...",
        dataRetrievalError: "خطأ أثناء استرداد البيانات",
        activityFollowUpHistory: "متابعة الاعمال المنزلية لتلاميذ ",
        verificationDate: "تاريخ التحقق",
        numberOfStudents: "عدد التلاميذ",
        student:"التلميذ",
        followUp: "متابعة",
        date: "التاريخ",
        retrievingClassesAndSubjects: "استرداد الفصول والمواد",
        operationInProgress: "العملية قيد التنفيذ ...",
        activitySaved: "تم تسجيل النشاط بنجاح",
        activitySaveError: "خطأ أثناء تسجيل النشاط",
        activityDelition : "تم حذف النشاط بنجاح",
        activityDelitionError : "خطأ أثناء حذف النشاط",
        activityModified: "تم تعديل النشاط بنجاح",
        activityModificationError: "خطأ أثناء تعديل النشاط",
        statusModified: "تم تعديل الحالة بنجاح",
        modificationError: "خطأ أثناء تسجيل التعديلات",
        followUpDelition : "تم حذف المتابعة بنجاح",
        followUpDelitionError : "خطأ أثناء حذف المتابعة",
        error_follow_add: "خطأ أثناء إضافة المتابعة",
        followUpDetails: "تفاصيل المتابعة",
        noDataAvailable: "لا توجد بيانات متاحة",
        noFollowUpsFound: "لا توجد متابعات موجودة",
        consult_follow_ups: "عرض المتابعة",
        search_follow_ups_class: "البحث عن المتابعات لفصل",
        from_date: "من",
        to_date: "إلى",
        search_button: "بحث",
        Tissoura_Private_School: "مدرسة تيسورة الخاصة",
        emptyFollowUpList: "قائمة المتابعات فارغة",
        note: "ملاحظة",
        homework_completed: "تم الواجب المنزلي ",
        preparation_without_effort:  "تم التحضير بدون مجهود(نقل) ",
        preparation_not_done: "لم يتم التحضير ",
        director: "المدير",
        school_administrator: "مسير المدرسة",
        cycle_responsible: "مسؤول الطور",
        Select : "اختر",
        searchStudentListForClass : "البحث عن قائمة التلاميذ لفصل",
        Teacher: " الاستاذ (ة)",
        academic_level: "المستوى الدراسي",
        administrative_discipline: "الانضباط الإداري",
        revision_and_memorization: "المراجعة و الحفظ",
        excellent_student: "تلميذ ممتاز : ",
        average_student: "تلميذ متوسط : ",
        weak_student: "تلميذ ضعيف : ",
        evaluateStudents : "تقييم التلاميذ",
        studentEvaluationInfo : "معلومات حول تقييم التلاميذ",
        evaluationType : "نوع التقييم",
        evaluationSavedSuccess: "لقد تم حفظ التقييم بنجاح",
        evaluationSaveError: "خطأ أثناء حفظ التقييم",
        ViewEvaluation : "عرض التقييم",
        searchEvaluationResultsForClass: "البحث عن نتائج التقييم لفصل",
        empty_evaluation_list: "قائمة التقييم فارغة",
        evaluationModifiedSuccess: "تم تعديل التقييم بنجاح",
        evaluationDeletedSuccess: "تم حذف التقييم بنجاح",
        evaluationDeleteError: "خطأ أثناء حذف التقييم",
        studentStatistics:  "إحصائيات التلاميذ",
        searchStudentStatisticsInPeriod: "البحث عن إحصائيات التلاميذ في فترة محددة",
        supportClasses: "دروس الدعم",
        supportClassesList: "قائمة دروس الدعم",
        addSupportClass: "إضافة درس الدعم",
        supportClassRecorded: "تم تسجيل درس الدعم بنجاح",
        supportClassRecordError: "خطأ أثناء تسجيل درس الدعم",
        supportClassDeleted: "تم حذف درس الدعم بنجاح",
        supportClassDeleteError: "خطأ أثناء حذف درس الدعم",
        editSupportClass: "تعديل درس الدعم",
        supportClassEdited: "تم تعديل درس الدعم بنجاح",
        supportClassEditError: "خطأ أثناء تعديل درس الدعم",
        supportClassFollowUp: "متابعة درس الدعم",
        understandingLesson: "فهم الدرس",
        understandingExercise: "فهم التمرين",
        supportLessonFollowUp: "متابعة دروس الدعم لتلاميذ ",
        lessonOrExerciseUnderstood: "تم فهم الدرس أو التمرين",
        lessonOrExerciseNotUnderstood: "لم يتم فهم الدرس أو التمرين",
        notConfirmedWithStudent: "لم يتم التأكيد مع التلميذ",
        studentReport: "تقرير التلميذ ",
        Activities: "الأنشطة",
        weeks: "الأسابيع",
        percentage: "نسبة مئوية",
        studentProgressCurve: "منحنى تطور التلميذ",
        meeting_form: "استمارة الاجتماع",
        parent_teacher_meeting_form: "استمارة اجتماع ولي الأمر مع الأستاذ",
        time: "الساعة",
        purpose_of_meeting: "هدف الاجتماع",
        Scheduled: "مجدول",
        IN_PROGRESS: "قيد التنفيذ",
        Completed: "مكتمل",
        Cancelled: "ملغى",
        Canceled: "ملغى",
        Rescheduled: "معاد جدولته",
        meeting_saved_successfully: "لقد تم حفظ الاجتماع بنجاح",
        error_saving_meeting: "خطأ أثناء حفظ الاجتماع",
        Recruitment: "التوظيف",
        JobList: "قائمة الوظائف",
        applicationDeadline: "الموعد النهائي للتقديم",
        page: "صفحة",
        department: "القسم",
        jobRequirements: "متطلبات الوظيفة",
        salaryRange: "نطاق الراتب",
        jobOpened: "الوظيفة مفتوحة",
        jobClosed: "الوظيفة مغلقة",
        addJob: "إضافة وظيفة",
        jobTitle: "المسمى الوظيفي",
        editJob: "تعديل الوظيفة",
        candidateList: "قائمة المرشحين",
        coverLetter: "خطاب التقديم",
        interviewList: "قائمة المقابلات",
        appointment: "تاريخ المقابلة",
        location: "الموقع",
        notes: "ملاحظات",
        addInterview: "اضافة مقابلة",
        interviewSavedSuccess: "تم حفظ المقابلة بنجاح",
        interviewSaveError: "خطأ أثناء حفظ المقابلة",
        edit_interview: "تعديل المقابلة",
        edit_interview_success: "تم تعديل المقابلة بنجاح",
        edit_interview_error: "خطأ أثناء تعديل المقابلة",
        Meetings: "اجتماعات",
        listOfMeetings: "قائمة الاجتماعات",
        parent: "ولي الأمر",
        Phase1: "المرحلة 1",
        Phase2: "المرحلة 2",
        Phase3: "المرحلة 3",
        send_email: "إرسال البريد الإلكتروني",
        new_message: "رسالة جديدة",
        email_sent_success: "تم إرسال البريد الإلكتروني بنجاح",
        email_sent_error: "خطأ اثناء إرسال البريد الإلكتروني",
        meeting_updated_successfully: "لقد تم تعديل الاجتماع بنجاح",
        error_updating_meeting: "خطأ أثناء تعديل الاجتماع",
        meeting_deleted_successfully: "تم حذف الاجتماع بنجاح",
        error_deleting_meeting: "خطأ أثناء حذف الاجتماع",
        email_saved_success: "تم حفظ البريد الإلكتروني بنجاح",
        email_saved_error: "خطأ أثناء حفظ البريد الإلكتروني" ,
        sendEmails: "إرسال الرسائل",
        score: "التقييم",
        accepted_candidates_list: "قائمة المرشحين المقبولين لمنصب",
        empty_candidates_list:  "قائمة المرشحين المقبولين  فارغة ",
        organizations: "المؤسسات",
        institutions: "المنشآت",
        levels: "المستويات",
        classes: "الأقسام",
        subjects: "المواد الدراسية",
        teachers: "المعلمون",
        payments: "الدفعات",
        products: "المنتجات",
        enrollments: "التسجيلات",
        schedules: "الجداول الزمنية",
        attendances: "الحضور",
        tickets: "التذاكر",
        abilities: "القدرات",
        my_account: "حسابي",
        parents: "الأولياء",
        positions: "المناصب",
        employees: "الموظفون",
        schooling: "التعليم",
        organizationManagement: "إدارة المؤسسات",
        createOrganization: "إضافة مؤسسة",
        organizationName: "اسم المؤسسة",
        mainUrl: "الرابط الرئيسي",
        directorName: "اسم المدير",
        coDirectorName: "اسم المدير المساعد",
        userManagement: "إدارة المستخدمين",
        createUser: "إضافة مستخدم",
        organizationDetails: "تفاصيل المؤسسة",
        newDirectorDetails: "تفاصيل المدير الجديد",
        editOrganization: "تعديل المؤسسة",
        addOrganization: "إضافة مؤسسة",
        cancel: "إلغاء",
        institutionManagement: "إدارة المنشآت",
        createInstitution: "اضافة منشأة",
        institutionName: "اسم المنشأة",
        phones: "أرقام الهواتف",
        managerName: "اسم المدير",
        editInstitution: "تعديل المنشأة",
        addInstitution: "إضافة منشأة",
        AddPhone: "إضافة هاتف",
        Remove: "إزالة",
        studentManagement: "إدارة التلاميذ",
        createStudent: "اضافة تلميذ",
        studentName: "اسم التلميذ",
        gradeLevel: "المستوى الدراسي",
        parentName: "اسم الوالد",
        relationshipToParent: "العلاقة بالوالد",
        organizationFullName: "الاسم الكامل للمؤسسة",
        addStudent: "إضافة تلميذ",
        Active: "نشط",
        Inactive: "غير نشط",
        Pending: "قيد الانتظار",
        User: "مستخدم",
        Level: "المستوى",
        Institution: "المنشأة",
        classManagement: "إدارة الاقسام ",
        createClass: "إضافة قسم",
        className: "اسم القسم",
        level: "المستوى",
        service: "خدمة",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        schoolYearT: "السنة الدراسية",
        unitPrice: "سعر الوحدة",
        unitCount: "عدد الوحدات",
        subjectManagement: "إدارة المواد",
        createSubject: "إضافة مادة",
        subjectName: "اسم المادة",
        organization: "المؤسسة",
        addSubject: "إضافة مادة",
        addClass: "إضافة قسم ",
        dateOfBirth: "تاريخ الميلاد",
        Technology: "تكنولوجيا",
        Healthcare: "الرعاية الصحية",
        Finance: "المالية",
        Retail: "التجزئة",
        Education: "التعليم",
        PrivateSchool: "مدرسة خاصة",
        School: "مدرسة",
        Ecommerce: "التجارة الإلكترونية",
        Petzeria: "مطعم بيتزا",
        Restaurant: "مطعم",
        industry: "صناعة",
        AddDirector: "إضافة مدير",
        Director: "مدير",
        institutionFullName: "الاسم الكامل للمنشأة",
        Partners: "الشركاء",
        manager: "المدير",
        addManager: "إضافة مدير",
        NewManagerDetails: "تفاصيل المدير الجديد",
        AddNewStudent: "إضافة طالب جديد",
        parentManagement: "إدارة أولياء الأمور",
        createParent: "إضافة ولي أمر",
        addParent: "إضافة ولي أمر",
        ParentInformation: "معلومات ولي الأمر",
        AddNewParent: "إضافة ولي أمر جديد",
        SelectParent: "اختيار ولي أمر",
        ChildrenInformation: "معلومات الأطفال",
        SelectChild: "اختيار طفل",
        Relationship: "العلاقة",
        Mother: "الأم",
        Father: "الأب",
        Guardian: "الوصي",
        Stepmother: "زوجة الأب",
        Stepfather: "زوج الأم",
        Grandparent: "الجد/الجدة",
        Other: "أخرى",
        AddChild: "إضافة طفل",
        teacherManagement: "إدارة المعلمين",
        createTeacher: "إضافة معلم",
        subjectsTaught: "المواد التي يتم تدريسها",
        addTeacher: "إضافة معلم",
        levelManagement: "إدارة المستويات",
        createLevel: "إضافة مستوى",
        levelName: "اسم المستوى",
        type: "النوع",
        editLevel: "تعديل المستوى",
        editParent: "تعديل ولي الأمر",
        editClass: "تعديل القسم ",
        editSubject: "تعديل المادة",
        editTeacher: "تعديل المعلم",
        editStudent: "تعديل التلميذ",
        editUser: "تعديل المستخدم",
        PreInvoiceDetails: " الفاتورة المبدئية",
        Invoices: "الفواتير",
        paymentManagement: "إدارة المدفوعات",
        createPayment: "إضافة دفعة",
        invoice: "فاتورة",
        paymentDate: "تاريخ الدفع",
        amount: "المبلغ",
        addPayment: "إضافة دفعة",
        editPayment: "تعديل الدفعة",
        preInvoiceDManagement: "إدارة الفواتير الأولية",
        createPreInvoiceD: "إضافة فاتورة أولية",
        item: "عنصر",
        total: "المجموع",
        consumedCount: "عدد المستهلك",
        editPreInvoiceD: "تعديل الفاتورة الأولية",
        addPreInvoiceD: "إضافة فاتورة أولية",
        invoiceManagement: "إدارة الفواتير",
        createInvoice: "إضافة فاتورة",
        editInvoice: "تعديل الفاتورة",
        addInvoice: "إضافة فاتورة",
        DateIssued: "تاريخ الإصدار",
        InvoiceDetails: "تفاصيل الفاتورة",
        Discount: "خصم",
        NetAmount: "المبلغ الصافي",
        AddItem: "إضافة عنصر",
        InstallmentCount: "عدد الأقساط",
        TotalAmount: "المبلغ الإجمالي",
        Unpaid: "غير مدفوع",
        Paid: "مدفوع",
        Overdue: "متأخر",
        SelectItem: "اختيار عنصر",
        addLevel: "إضافة مستوى",
        Regular: "نظامي",
        Support: "دعم",
        Training: "تدريب",
        employeeManagement: "إدارة الموظفين",
        createEmployee: "إضافة موظف",
        editEmployee: "تعديل موظف",
        addEmployee: "إضافة موظف",
        position: "الوظيفة",
        salary: "الراتب",
        benefits: "المزايا",
        contractDocument: "وثيقة العقد",
        employeeName: "اسم الموظف",
        positionTitle: "المسمى الوظيفي",
        serviceManagement: "إدارة الخدمات",
        createService: "إنشاء خدمة",
        editService: "تعديل خدمة",
        addService: "إضافة خدمة",
        ServiceCode: "رمز الخدمة",
        ServiceName: "اسم الخدمة",
        DefaultUnitPrice: "السعر الافتراضي للوحدة",
        Available: "متاح",
        Unavailable: "غير متاح",
        DefaultUnitCount: "العدد الافتراضي للوحدات",
        productManagement: "إدارة المنتجات",
        createProduct: "إضافة منتج",
        editProduct: "تعديل المنتج",
        addProduct: "إضافة منتج",
        ProductName: "اسم المنتج",
        enrollmentManagement: "إدارة التسجيلات",
        createEnrollment: "إضافة تسجيل",
        editEnrollment: "تعديل التسجيل",
        addEnrollment: "إضافة تسجيل",
        Enrolled: "مسجل",
        Dropped: "منسحب",
        EnrollmentDate: "تاريخ التسجيل",
        scheduleManagement: "إدارة الجداول",
        createSchedule: "إضافة جدول",
        editSchedule: "تعديل الجدول",
        addSchedule: "إضافة جدول",
        HourVolume: "عدد الساعات",
        DayOfWeek: "يوم الأسبوع",
        StartTime: "وقت البدء",
        EndTime: "وقت الانتهاء",
        Location: "الموقع",
        attendanceManagement: "إدارة الحضور",
        createAttendance: "إضافة سجل حضور",
        editAttendance: "تعديل سجل الحضور",
        addAttendance: "إضافة سجل حضور",
        Schedule: "الجدول",
        Date: "التاريخ",
        InReview: "قيد المراجعة",
        Reviewed: "تمت المراجعة",
        Approved: "تمت الموافقة",
        Reported: "تم الإبلاغ",
        AttendanceStatus: "حالة الحضور",
        Present: "حاضر",
        Absent: "غائب",
        Late: "متأخر",
        AddStudent: "إضافة تلميذ ",
        studentAttendance: "حضور التلاميذ ",
        teacherAttendance: "حضور المعلمين",
        ticketManagement: "إدارة التذاكر",
        createTicket: "إضافة تذكرة",
        addTicket: "إضافة تذكرة",
        editTicket: "تعديل تذكرة",
        OPEN: "مفتوح",
        CLOSED: "مغلق",
        Priority: "الأولوية",
        low: "منخفض",
        medium: "متوسط",
        high: "عالي",
        Comments: "التعليقات",
        AddComment: "إضافة تعليق",
        Attachments: "المرفقات",
        AddAttachment: "إضافة مرفق",
        assignee: "المكلف",
        abilitiesManagement: "إدارة القدرات",
        createAbility: "إضافة قدرة",
        resetAbilities: "إعادة تعيين القدرات",
        deleteAbilities: "حذف القدرات",
        updateAbilities: "تحديث القدرات",
        cloneAbilities: "استنساخ القدرات",
        roleName: "اسم الدور",
        origin: "الأصل",
        abilitiesCount: "عدد القدرات",
        NewRoleName: "اسم الدور الجديد",
        Manage: "إدارة",
        Create: "إنشاء",
        Read: "قراءة",
        Update: "تحديث",
        Delete: "حذف",
        Documents: "المستندات",
        notificationSettings: "إعدادات الإشعارات",
        enabled: "مفعل",
        disabled: "معطل",
        emailNotifications: "إشعارات البريد الإلكتروني",
        pushNotifications: "الإشعارات الفورية",
        appearanceSettings: "إعدادات المظهر",
        languageSettings: "إعدادات اللغة",
        language: "اللغة",
        french: "الفرنسية",
        english: "الإنجليزية",
        arabic: "العربية",
        additionalSettings: "إعدادات إضافية",
        otherSettings: "إعدادات أخرى",
        AccountStatus: "حالة الحساب",
        saveChanges: "حفظ التغييرات",
        changePassword: "تغيير كلمة المرور",
        currentPassword: "كلمة المرور الحالية",
        newPassword: "كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور",
        updatePassword: "تحديث كلمة المرور",
        title2: "العنوان",
        AddManager: "إضافة مدير",
        newRoleName: "اسم الدور الجديد",
        reloadData: "إعادة تحميل البيانات",
        SearchStudents: "البحث عن التلاميذ",
        firstName: "اللقب",
        lastName: "الاسم",
        writing_training: "تعليم الكتابة",
        english_training: "تعليم الإنجليزية",
        quran_training: "تعليم القرآن",
        teacher: "المعلم",
        teacherName: "اسم المعلم",
        all: "الكل",
        read: "مقروء",
        not_read: "غير مقروء",
        filter_by_status: "تصفية حسب الحالة",
        grades: "النقاط",
        assignment: "الفرض",
        exam: "الاختبار",
        exercise_count: "عدد التمارين",
        assignment_points: "نقاط الفرض في مادة",
        exercise_point: "نقطة التمرين",
        activity_evaluation_rate: "معدل تقويم النشاطات",
        grades2: "التقديرات",
        exercice: "التمرين",
        integration_status: "الوضعية الادماجية",
        points: "نقاط",
        product: "منتج",
        payment_received: "وصل الدفع",
        period: "الفترة",
        payment: "الدفع",
        remaining_balance: "الباقي للدفع",
        total_amount: "المبلغ الإجمالي",
        total_payment_received: "إجمالي المبلغ المستلم",
        filter_payment_receipts: "تصفية إيصالات الدفع",
        student_in_period: "التلميذ في فترة",
        user_in_period: "المستخدم في فترة",
        NewDirectorDetails: "تفاصيل المدير الجديد",
        print: "طباعة",
        positionManagement: "إدارة المناصب",
        filledPositions: "المناصب المشغولة",
        authorizedPositions: "المناصب المصرح بها",
        createPosition: "إنشاء منصب",
        editPosition: "تعديل منصب",
        addPosition: "إضافة منصب",
        by: "حسب",
        filterInvoices: "تصفية الفواتير",
        message_sent_success: "تم إرسال الرسالة بنجاح",
        message_sent_error: "حدث خطأ أثناء إرسال الرسالة",
        select_organization: "اختر مؤسسة",
        select_institution: "اختر منشأة",
        select_class: "اختر قسم",
        listIsEmpty: "القائمة فارغة",
        myChildren: "أبنائي",
        Remedial: "معالجة",
        comments: "تعليقات",
        attachments: "مرفقات",
        Browse: "تصفح",
        Filename: "اسم الملف",
        Comment: "تعليق",
        addRole: "إضافة دور",
        Parameters: "المعلمات",
        roleName: "اسم الدور",
        Role: "الدور",
        editRole: "تعديل الدور",
        userRoles: "أدوار المستخدم",
        statistics: "الاحصائيات",
        operationSuccessful: "تمت العملية بنجاح!",
        confirmDelete: "تأكيد الحذف",
        areYouSureYouWantToDelete: "هل أنت متأكد أنك تريد الحذف؟",
        delete: "حذف",
        algerianDemocraticRepublic: "الجمهورية الجزائرية الديمقراطية الشعبية",
        ministryOfEducation: "وزارة التربية الوطنية",
        educationDirectorateTlemcen: "مديرية التربية لولاية تلمسان",
        schoolYear: " السنة الدراسية",
        tissouraMansoura: "-تيسورة الخاصة-منصورة",
        number: " الرقم",
        schoolCertificate: "شهادة مدرسية",
        certificateDirectorStatement: ": يشهد السيد (ة) مدير (ة) المؤسسة أن التلميذ",
        certificateBirthInfo: ": تاريخ و مكان الازدياد",
        certificateStudyStatus: "يتابع دراسته",
        registrationNumber: ":  رقم التسجيل",
        issuedInMansoura: ": حرر بمنصورة في",
        previousNameAndSurnameWriting: "الكتابة السابقة للاسم و اللقب",
        schoolDirector: "مدير (ة) المؤسسة",
        tissouraPrivateSchool: "تيسورة الخاصة",
        educational_group: "الفوج التربوي",
        issued_by: "صدرت ب",
        mansoura: "منصورة",
        school_id_number: "رقم التعريف المدرسي",
        exit_date: "تاريخ الخروج",
        to_this_day: "الى يومنا هذا",
        newPassword: "كلمة المرور الجديدة",
        resetPassword: "إعادة تعيين كلمة المرور",
        student_exit_log: "سجل الخروج",
        logout_record: "سجل الخروج",
        teacher_schedule: "جدول المعلم",
        class_schedule: "جدول القسم",
        print_teacher_schedule: "طباعة جدول الاستاذ",
        Monday: "الاثنين",
        Tuesday: "الثلاثاء",
        Wednesday: "الأربعاء",
        Thursday: "الخميس",
        Friday: "الجمعة",
        Saturday: "السبت",
        Sunday: "الأحد",
        teacher_schedule: "استعمال الزمن للاستاذ",
        placeOfBirth: "مكان الازدياد",
        location: ": ب",
        number_of_minutes: "عدد الدقائق",
        due_date: " تاريخ الاستحقاق ",
        guide_title: "دليل وحدة 'التلاميذ'",
        add_student: "إضافة تلميذ جديد",
        modify_student: "تعديل معلومات التلميذ",
        step1: "تسجيل الدخول إلى التطبيق.",
        step2: "الانتقال إلى وحدة 'التلاميذ' من القائمة الرئيسية.",
        step3: " انقر على زر إضافة تلميذ",
        step4: "املأ المعلومات المطلوبة (المستخدم، المستوى، المؤسسة، إلخ)",
        step5: "انقر على 'حفظ' لإضافة  التلميذ ",
        edit_student_info: "لتعديل معلومات التلميذ اضغط على",
        save_student_info: "انقر على 'حفظ' لحفظ معلومات التلميذ",
        user_not_found: "  اذا لم تجد المستخدم في القائمة اضغط على اضافة طالب جديد",
        fill_save_info: " املا المعلومات المطلوبة ثم اضغط على حفظ ",
        generate_school_certificate: "لاستخراج شهادة مدرسية اضغط على",
        classes_guide: "دليل وحدة 'الأقسام'",
        add_new_class: "إضافة قسم جديد",
        navigate_to_classes: "الانتقال إلى وحدة 'التعليم' من القائمة الرئيسية.",
        click_add_class: "انقر على زر إضافة قسم",
        fill_required_info_c: "املأ المعلومات المطلوبة (اسم القسم، المستوى، السنة الدراسيةا, الخ)",
        click_save_class: "انقر على 'حفظ' لإضافة القسم",
        click_save_edit_class: "انقر على 'حفظ' لحفظ القسم",
        click_save_class_info: "انقر على 'حفظ' لحفظ معلومات القسم",
        edit_class_info: "تعديل معلومات القسم",
        click_edit_class_info: "لتعديل معلومات القسم اضغط على",
        registration_procedure: "بروتوكول التسجيل",
        prepare_data: "تحضير البيانات",
        prepare_student: "إذا لم يتم إنشاء التلميذ بعد، قم بإنشائه من خلال دليل 'التلاميذ'.",
        prepare_class: "إذا لم تكن الاقسام الدراسية متاحة، قم بإنشائها من خلال دليل 'الأقسام'.",
        access_registration: "الوصول إلى وحدة 'التسجيلات'",
        select_registration_module: "من القائمة الرئيسية، اختر وحدة 'التسجيلات'.",
        create_registration: "إضافة تسجيل جديد",
        click_create_registration: "انقر على زر 'إضافة تسجيل'.",
        fill_registration_info: "ملء المعلومات المطلوبة",
        registration_details: "حدد وأدخل المعلومات التالية: التلميذ، القسم، تاريخ التسجيل، المؤسسة، الحالة.",
        save_registration: "حفظ التسجيل",
        click_save_registration: "انقر على زر 'حفظ' لحفظ التسجيل.",
        see_guide: "عرض الدليل",
        activities_unit_guide: "دليل وحدة 'الأنشطة'",
        add_new_activity: "إضافة نشاط جديد",
        go_to_students_unit: "الانتقال إلى وحدة 'التلاميذ' من القائمة الرئيسية",
        fill_required_information: "املأ المعلومات المطلوبة (المادة، القسم، الوصف ، إلخ)",
        go_to_activities_unit: "الانتقال إلى وحدة 'الأنشطة' من القائمة الثانوية",
        click_add_button: "انقر على زر اضف",
        click_save_to_add_activity: "انقر على 'حفظ' لإضافة النشاط",
        module_description: "تتيح هذه الوحدة متابعة الأنشطة المعينة للتلاميذ، مما يسهل إضافة الأنشطة وإدارتها ومتابعتها، مع تمكين التنقل السلس بين وحدتي 'الأنشطة' و 'التلاميذ'.",
        edit_activity_information: "تعديل معلومات النشاط",
        to_edit_activity_information_click_on: "لتعديل معلومات النشاط اضغط على",
        click_save_to_save_activity: "انقر على 'حفظ' لحفظ النشاط",
        to_add_follow_up_to_activity_click_on: "لإضافة متابعة للنشاط اضغط على",
        to_view_activity_follow_ups_click_on: "لرؤية متابعات النشاط اضغط على",
        add_follow_up_to_activity: "إضافة متابعة للنشاط",
        to_view_follow_up_details_click_on: "لرؤية تفاصيل المتابعة اضغط على",
        to_edit_follow_up_click_on: "لتعديل المتابعة اضغط على",
        to_delete_follow_up_click_on: "لحذف المتابعة اضغط على",
        to_view_activity_follow_ups_for_section_in_period_click_on: "لرؤية متابعات الأنشطة لقسم في مدة معينة اضغط على زر عرض المتابعة",
        to_view_students_work_statistics_click_on: "لرؤية إحصائيات عمل التلاميذ اضغط على إحصائيات التلاميذ",
        to_view_specific_student_report_click_on: "لرؤية تقرير تلميذ معين اضغط على تقرير التلميذ",
        follow_up_protocol: "بروتوكول متابعة الأنشطة",
        create_activity: "إضافة نشاط",
        create_follow_up: "إضافة متابعة واحدة أو أكثر للنشاط",
        consult_follow_up: "استعراض المتابعات في فترة معينة",
        support_lessons_guide: "دليل وحدة 'دروس الدعم'",
        navigate_support_lessons: "الانتقال إلى وحدة 'دروس الدعم' من القائمة الثانوية",
        save_support_lesson: "انقر على 'حفظ' لحفظ درس الدعم",
        add_support_lesson: "إضافة درس الدعم",
        modify_support_lesson: "تعديل درس الدعم",
        modify_support_lesson_info: "لتعديل معلومات درس الدعم اضغط على",
        click_save_to_save_support_lesson: "انقر على حفظ لحفظ درس الدعم",
        add_follow_up_to_support_lesson: "لاضافة متابعة لدرس الدعم اضغط على",
        view_follow_up_for_support_lesson: "لرؤية متابعة درس الدعم اضغط على",
        modify_and_save_follow_up: "يمكن تعديل المتابعة ثم الضغط على حفظ",
        support_lesson_follow_up_module_description: "تتيح هذه الوحدة متابعة دروس الدعم للتلاميذ",
        requests: "الطلبات",
        createRequest: "إضافة طلب",
        filterRequest: "تصفية الطلبات",
        Pending: "قيد الانتظار",
        Purchased: "تم الشراء",
        manage_requests: "إدارة الطلبات",
        editRequest: "تعديل الطلب",
        requestDetails: "تفاصيل الطلب",
        notebookTracking: "متابعة الكراريس",
        addTracking: "إضافة متابعة",
        trackingAddedSuccess: "تم إضافة المتابعة بنجاح",
        trackingUpdatedSuccess: "تم تعديل المتابعة بنجاح",
        editTracking: "تعديل المتابعة",
        lessonCompleted: "تم اكمال الدرس",
        lessonNotCompleted: "لم يتم اكمال الدرس",
        handwritingImprovement: "تحسين الخط",
        inProgress: "قيد التنفيذ",
        consult_follow_up_SC: "لرؤية متابعات دروس الدعم لقسم في مدة معينة اضغط على زر عرض المتابعة",
        behavior_module_guide: "دليل وحدة  'السلوك'",
        behavior_module_description: "تتيح هذه الوحدة متابعة سلوك التلاميذ",
        navigate_behavior_module: "الانتقال إلى وحدة 'السلوك' من القائمة الثانوية",
        click_evaluate_students: "انقر على زر' تقييم التلاميذ'",
        fill_required_info: "املأ المعلومات المطلوبة : المادة، القسم، نوع التقييم،إلخ",
        click_save: "اضغط على 'حفظ'",
        evaluate_each_student: "قيم كل تلميذ حسب مستواه (A , B , C)",
        view_evaluation: "لعرض التقييم حسب المادة والقسم في فترة معينة اضغط على 'عرض التقييم'",
        notebook_tracking_guide: "دليل وحدة 'متابعة الكراريس'",
        notebook_tracking_description: "تتيح هذه الوحدة متابعة 'كراريس التلاميذ'",
        navigate_notebook_tracking: "الانتقال إلى وحدة 'متابعة الكراريس' من القائمة الثانوية",
        fill_required_info_notebook: "املأ المعلومات المطلوبة (المادة، القسم، المنشأة، إلخ)",
        click_on: "اضغط على",
        edit_tracking_info: "لتعديل معلومات المتابعة اضغط على",
        view_tracking_details: "لرؤية تفاصيل المتابعة اضغط على",
        view_notebook_tracking: "لرؤية متابعات الكراريس لقسم في مدة معينة اضغط على زر عرض المتابعة (يمكن العرض حسب مادة معينة)",
        meetings_module_guide: "دليل وحدة 'الاجتماعات'",
        meetings_module_description: "تتيح هذه الوحدة إدارة الاجتماعات بين الأساتذة وأولياء التلاميذ.",
        navigate_meetings_module: "الانتقال إلى وحدة 'الاجتماعات' من القائمة الثانوية.",
        add_meeting: "إضافة اجتماع",
        click_meeting_form: "اضغط على استمارة الاجتماع",
        fill_meeting_info: "املأ المعلومات المطلوبة : الأستاذ، ولي الأمر، التاريخ، إلخ",
        edit_meeting_info: "لتعديل معلومات الاجتماع اضغط على",
        view_meeting_details: "لرؤية تفاصيل الاجتماع اضغط على",
        support_course_tracking_protocol: "بروتوكول متابعة دروس الدعم",
        add_support_course: "إضافة درس الدعم",
        add_support_course_tracking: "إضافة متابعة لدرس الدعم",
        view_support_course_tracking: "استعراض المتابعات في فترة معينة (يمكن العرض حسب المادة)",
        add_notebook_tracking: "إضافة متابعة للكراريس",
        add_tracking_details: "إضافة تفاصيل المتابعة بعد مراقبة كراريس التلاميذ",
        view_notebook_tracking_P: "استعراض متابعات الكراريس في فترة معينة (يمكن العرض حسب المادة)",
        notebook_tracking_protocol: "بروتوكول متابعة الكراريس",
        payroll:  "الاجور",
        PayPeriod: "فترة الدفع",
        GrossPay: "الأجر الإجمالي",
        NetPay: "صافي الراتب",
        PaymentMethod: "طريقة الدفع",
        Employee: "الموظف",
        payroll_management: "إدارة الاجور ",
        create_payroll:  "إضافة الاجر",
        add_payroll: "إضافة الاجر",
        edit_payroll: "تعديل الاجر",
        MONTHLY: "شهري",
        PER_SESSION: "حسب الحصص",
        Cash: "نقدًا",
        PERCENTAGE: "النسبة المئوية",
        module_guide_subjects: "دليل وحدة 'المواد'",
        add_new_subject: "إضافة مادة جديدة",
        navigate_to_subjects_module: "الانتقال إلى وحدة 'المواد الدراسية' من القائمة الثانوية",
        click_add_subject: "انقر على زر إضافة مادة",
        click_save_to_add_subject: "انقر على 'حفظ' لإضافة المادة",
        fill_required_information_s: "املأ المعلومات المطلوبة (اسم المادة، الوصف، المستوى, الخ)",
        edit_subject_information: "تعديل معلومات المادة",
        click_to_edit_subject_information: "لتعديل معلومات المادة اضغط على",
        click_save_to_save_subject: "انقر على 'حفظ' لحفظ المادة",
        reports: "التقارير",
        create_report: "إضافة تقرير",
        manage_reports: "إدارة التقارير",
        title: "العنوان",
        description: "الوصف",
        date_of_report: "تاريخ التقرير",
        file_url: "رابط الملف",
        add_report: "إضافة تقرير",
        edit_report: "تعديل التقرير",
        created_by: "أنشئ بواسطة",
        canceled: "ملغى",
        print_payment_notice: "طباعة إشعار ",
        payment_notice_on: "إشعار الدفع في :",
        education_levels: "تحضيري - ابتدائي - متوسط",
        print_student_list: "طباعة قائمة التلاميذ",
        number_of_sessions: "عدد الحصص",
        minutes: "دقيقة",
        call_management: "إدارة المكالمات",
        calls: "المكالمات",
        contact_list: "قائمة جهات الاتصال",
        course_schedule: "التوزيع الزمني ",       
        print_course_schedule: "طباعة التوزيع الزمني ",
        day: "اليوم",
        timeS : "الساعة",
        phone_number: "رقم الهاتف",
        remaining: "المتبقي",
        levels_module_guide: "دليل وحدة 'المستويات'",
        add_new_level: "إضافة مستوى جديد",
        navigate_to_levels_module: "الانتقال إلى وحدة 'المستويات' من القائمة الثانوية.",
        click_add_level: "انقر على زر إضافة مستوى.",
        fill_required_level_information: "املأ المعلومات المطلوبة (اسم المستوى، الوصف، الخ).",
        click_save_to_add_level: "انقر على 'حفظ' لإضافة المستوى.",
        edit_level_information: "تعديل معلومات المستوى",
        click_to_edit_level_information: "لتعديل معلومات المستوى اضغط على",
        click_save_to_save_level: "انقر على 'حفظ' لحفظ المستوى",
        create_subjects_if_not_available: "إذا لم تكن المواد الدراسية متاحة، قم بإنشائها من خلال دليل 'المواد'",
        enroll_students_in_classes: "تسجيل التلاميذ في الأقسام",
        add_ability: "إضافة قدرة",
        edit_ability: "تعديل القدرة",
        action: "الإجراء",
        subject: "الموضوع",
        conditions_json: "الشروط (JSON)",
        updating: "جارٍ التحديث...",
        update_abilities: "تحديث القدرات",
        add_role: "إضافة دور",
        accounting: "المحاسبة",
        accounts: "الحسابات",
        transaction_journal: "سجل المعاملات",
        owner_name: "اسم المالك",
        balance: "الرصيد",
        add_account: "إضافة حساب",
        edit_account: "تعديل حساب",
        accounts_management: "إدارة الحسابات",
        owner_type: "نوع مالك الحساب",
        remaining_amount: " المتبقي",
        to_be_paid: "للدفع",
        pay_invoices: "دفع الفواتير",
        refund_receipt: "وصل استرداد",
        refund: "استرداد",
        observation: "ملاحظة",
        signature: "الامضاء",
        and: "و",
        payment_statement: "كشف الحساب",
        refund_date: "تاريخ الاسترداد",
        allClasses: "جميع الأقسام",
        sessions : "حصص",
        week: "الأسبوع",
        student_not_registered: "التلميذ غير مسجل",
        hello: "مرحبا",
        json_export_error: "حدث خطأ أثناء تحميل بيانات JSON.",
        add_industry: "إضافة صناعة",
        edit_industry: "تعديل الصناعة",
        upload_json_file: "رفع ملف JSON",
        selected_file: "الملف المحدد :",
        json_file: "ملف JSON",
        choose_file: "اختر ملفًا",
        please_select_a_file: "يرجى تحديد ملف",
        invalid_json_file: "ملف JSON غير صالح!",
        Personal: "شخصي",
        Editing: "تعديل",
        validation_failed: "فشل التحقق: يرجى التأكد من ملء جميع الحقول ",
        approved_by_ministry: "معتمدة من وزارة التربية",
        net: "صافي",
        rc : "ر.س.ت",
        nif : "ر.ت.ج",
        emailInvoice : "ب.إ",
        invoice_journal: "سجل الفواتير",
        totalInvoice: "مجموع",
        agent_signature: "توقيع الإداري",
        institution_stamp: "ختم المؤسسة",
        tel : "ر.ه",
        amount_in_words: "المبلغ بالحروف",
        dzd: "دينار جزائري",
        fb : "ف.ب",
        client: "الزبون",
        payment_journal: "سجل الدفعات",
        until: "إلى غاية",
        subTitle: "العنوان الفرعي",
        Confirmed: "تم التأكيد",
        Billed: "تم إصدار الفاتورة",
        add_preinvoices: "إضافة فواتير أولية" ,
        schoolLevels: "المراحل الدراسية",
        PRIMARY: "مدرسة ابتدائية",
        MIDDLE: "مدرسة متوسطة",
        SECONDARY: "مدرسة ثانوية",
        OTHER: "أخرى",
        category: "الفئة",
        TUITION: "الرسوم الدراسية",
        TRANSPORT: "النقل",
        CANTEEN: "الإطعام",
        ACTIVITY: "نشاط",
        print_pre_invoices: "طباعة الفواتير الأولية",
        pre_invoices: "الفواتير الأولية",
        defaultUnit: "الوحدة الافتراضية",
        MONTH: "شهر",
        WEEK: "أسبوع",
        SEANCE: "حصة",
        UNITLESS: "بدون وحدة",
        all_services: "كل الخدمات",
        pre_invoice: "فاتورة مبدئية",
        transaction_journal: "سجل العمليات",
        number_of_registrations: "عدد التسجيلات",
        ministry_platform: "منصة الوزارة",
        black_list: "القائمة السوداء",
        code_class: "رمز القسم",
        level_code: "رمز المستوى",
        class_list: "قائمة الأقسام",
        totalS: "الكلي",
        verify_payment: "التحقق من الدفع",
        Exited: "تحويل",
        archive: "الأرشيف",
        maxStudents: "الحد الأقصى للتلاميذ",
        minStudents: "الحد الأدنى للتلاميذ",
        jobs: "الوظائف",
        unregistered_ministry: "عدد التلاميذ غير مسجلين في منصة الوزارة",
        Archived: "مؤرشف",
        Deleted: "محذوف",
        archiveStatus: "حالة الأرشفة",
        students_archive: "أرشيف التلاميذ",
        classes_archive: "أرشيف الأقسام",
        registrations_archive: "أرشيف التسجيلات",
        jobsManagement: "إدارة الوظائف",
        candidates: "المرشحون",
        teachers_archive: "أرشيف المعلمين",
        SPORT: "الرياضة",
        discountRate: "نسبة التخفيض",
        with_preinvoice_creation: "مع إنشاء فاتورة أولية",
        without_preinvoice_creation: "بدون إنشاء فاتورة أولية",
        groups: "المجموعات",
        group : "المجموعة",
        groups_management: "إدارة المجموعات",
        add_group: "إضافة مجموعة",
        edit_group: "تعديل المجموعة",
        group_name: "اسم المجموعة",
        code_group: "رمز المجموعة",
        referred_by: "موصى به من قبل",
        applicants: "المترشحون",
        applicantsManagement: "إدارة المترشحين",
        applicantName: "اسم المترشح",
        createApplicant: "إضافة مترشح",
        editApplicant: "تعديل المترشح",
        addNewApplicant: "إضافة مترشح جديد",
        preInvoice: "فاتورة أولية",
        pendingClass: "منتظر",
        ANNUAL: "رسوم التسجيل",
        applications: "طلبات التوظيف",
        applicationManagement: "إدارة طلبات التوظيف",
        createApplication: "إضافة طلب توظيف",
        ApplicationDate: "تاريخ طلب التوظيف",
        job: "الوظيفة",
        editApplication: "تعديل طلب التوظيف",
        applicant: "المترشح",
        editInterview: "تعديل المقابلة",
        createInterview: "إضافة مقابلة",
        AddTeacher: "إضافة معلم",
        totalAbsent: "إجمالي الغياب",
        totalLate: "إجمالي التأخر",
        totalPresent: "إجمالي الحضور",
        dailyAttendanceReport: "التقرير اليومي للمواظبة",
        justification: "مبرر",
        MedicalCertificate: "شهادة طبية",
        None: "لا شيء",
        reason: "السبب",
        PreEnrolled: "مبدئيًا مسجل",
        editRefund: "تعديل الاسترداد",
        mainList: "القائمة الرئيسية",
        followUpList: "قائمة المتابعة",
        creditStatus: "حالة الديون",
        subscribers: "المشتركين",
        subscribersManagement: "إدارة المشتركين",
        annualFeeManagement: "إدارة رسوم التسجيل",
        PartiallyPaid: "مدفوع جزئياً",
        individualBilling: "فوترة فردية",
        groupBilling: "فوترة جماعية",
        interviewer: "المحاور",
        humanResources: "الموارد البشرية",
        registrationLog: "سجل التسجيلات",
        subscribersLog: "سجل المشتركين",
        PHASE1: "المرحلة 1",
        PHASE2: "المرحلة 2",
        PHASE3: "المرحلة 3",
        PENDING: "قيد الانتظار",
        ACCEPTED: "مقبول",
        REJECTED: "مرفوض",
        UNDER_REVIEW: "قيد المراجعة",
        phase: "المرحلة",
        interviewResult: "نتيجة المقابلة",
        interviewNotes: "ملاحظات المقابلة",
        nis: "ر ت م"

      },
    },
  };
  export default resources;